var __defProp = Object.defineProperty,
    __typeError = (e) => {
        throw TypeError(e);
    },
    __defNormalProp = (e, t, i) => (t in e ? __defProp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : (e[t] = i)),
    __publicField = (e, t, i) => __defNormalProp(e, "symbol" != typeof t ? t + "" : t, i),
    __accessCheck = (e, t, i) => t.has(e) || __typeError("Cannot " + i),
    __privateGet = (e, t, i) => (__accessCheck(e, t, "read from private field"), i ? i.call(e) : t.get(e)),
    __privateAdd = (e, t, i) => (t.has(e) ? __typeError("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i)),
    __privateSet = (e, t, i, n) => (__accessCheck(e, t, "write to private field"), n ? n.call(e, i) : t.set(e, i), i),
    __privateMethod = (e, t, i) => (__accessCheck(e, t, "access private method"), i);
function Delegate(e) {
    (this.listenerMap = [{}, {}]), e && this.root(e), (this.handle = Delegate.prototype.handle.bind(this)), (this._removedListeners = []);
}
function matchesTag(e, t) {
    return e.toLowerCase() === t.tagName.toLowerCase();
}
function matchesRoot(e, t) {
    return this.rootElement === window ? t === document || t === document.documentElement || t === window : this.rootElement === t;
}
function matchesId(e, t) {
    return e === t.id;
}
(Delegate.prototype.root = function (e) {
    let t,
        i = this.listenerMap;
    if (this.rootElement) {
        for (t in i[1]) i[1].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !0);
        for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !1);
    }
    if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, this;
    for (t in ((this.rootElement = e), i[1])) i[1].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !0);
    for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !1);
    return this;
}),
    (Delegate.prototype.captureForType = function (e) {
        return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e);
    }),
    (Delegate.prototype.on = function (e, t, i, n) {
        let s, a, r, o;
        if (!e) throw TypeError("Invalid event type: " + e);
        if (("function" == typeof t && ((n = i), (i = t), (t = null)), void 0 === n && (n = this.captureForType(e)), "function" != typeof i)) throw TypeError("Handler must be a type of Function");
        return (
            (s = this.rootElement),
            (a = this.listenerMap[n ? 1 : 0])[e] || (s && s.addEventListener(e, this.handle, n), (a[e] = [])),
            t ? (/^[a-z]+$/i.test(t) ? ((o = t), (r = matchesTag)) : /^#[a-z0-9\-_]+$/i.test(t) ? ((o = t.slice(1)), (r = matchesId)) : ((o = t), (r = Element.prototype.matches))) : ((o = null), (r = matchesRoot.bind(this))),
            a[e].push({ selector: t, handler: i, matcher: r, matcherParam: o }),
            this
        );
    }),
    (Delegate.prototype.off = function (e, t, i, n) {
        let s, a, r, o, l;
        if (("function" == typeof t && ((n = i), (i = t), (t = null)), void 0 === n)) return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
        if (((r = this.listenerMap[n ? 1 : 0]), !e)) {
            for (l in r) r.hasOwnProperty(l) && this.off(l, t, i);
            return this;
        }
        if (!(o = r[e]) || !o.length) return this;
        for (s = o.length - 1; s >= 0; s--) (a = o[s]), (t && t !== a.selector) || (i && i !== a.handler) || (this._removedListeners.push(a), o.splice(s, 1));
        return o.length || (delete r[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)), this;
    }),
    (Delegate.prototype.handle = function (e) {
        let t,
            i,
            n,
            s,
            a,
            r,
            o,
            l = e.type,
            d = [],
            c = "ftLabsDelegateIgnore";
        if (!0 === e[c]) return;
        switch ((3 === (o = e.target).nodeType && (o = o.parentNode), o.correspondingUseElement && (o = o.correspondingUseElement), (n = this.rootElement), (s = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)))) {
            case 1:
                d = this.listenerMap[1][l];
                break;
            case 2:
                this.listenerMap[0] && this.listenerMap[0][l] && (d = d.concat(this.listenerMap[0][l])), this.listenerMap[1] && this.listenerMap[1][l] && (d = d.concat(this.listenerMap[1][l]));
                break;
            case 3:
                d = this.listenerMap[0][l];
        }
        let h,
            u = [];
        for (i = d.length; o && i; ) {
            for (t = 0; t < i && (a = d[t]); t++)
                o.tagName && ["button", "input", "select", "textarea"].indexOf(o.tagName.toLowerCase()) > -1 && o.hasAttribute("disabled") ? (u = []) : a.matcher.call(o, a.matcherParam, o) && u.push([e, o, a]);
            if (o === n || ((i = d.length), (o = o.parentElement || o.parentNode) instanceof HTMLDocument)) break;
        }
        for (t = 0; t < u.length; t++)
            if (!(this._removedListeners.indexOf(u[t][2]) > -1) && !1 === (r = this.fire.apply(this, u[t]))) {
                (u[t][0][c] = !0), u[t][0].preventDefault(), (h = !1);
                break;
            }
        return h;
    }),
    (Delegate.prototype.fire = function (e, t, i) {
        return i.handler.call(t, e, t);
    }),
    (Delegate.prototype.destroy = function () {
        this.off(), this.root();
    });
var main_default = Delegate,
    InputBindingManager = class {
        constructor() {
            (this.delegateElement = new main_default(document.body)), this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this));
        }
        _onValueChanged(e, t) {
            let i = document.getElementById(t.getAttribute("data-bind-value"));
            i && ("SELECT" === t.tagName && (t = t.options[t.selectedIndex]), (i.innerHTML = t.hasAttribute("title") ? t.getAttribute("title") : t.value));
        }
    };
function triggerEvent(e, t, i = {}) {
    e.dispatchEvent(new CustomEvent(t, { bubbles: !0, detail: i }));
}
function triggerNonBubblingEvent(e, t, i = {}) {
    e.dispatchEvent(new CustomEvent(t, { bubbles: !1, detail: i }));
}
var CustomHTMLElement = class extends HTMLElement {
        constructor() {
            super(),
                (this._hasSectionReloaded = !1),
                Shopify.designMode &&
                    this.rootDelegate.on("shopify:section:select", (e) => {
                        let t = this.closest(".shopify-section");
                        e.target === t && e.detail.load && (this._hasSectionReloaded = !0);
                    });
        }
        get rootDelegate() {
            return (this._rootDelegate = this._rootDelegate || new main_default(document.documentElement));
        }
        get delegate() {
            return (this._delegate = this._delegate || new main_default(this));
        }
        showLoadingBar() {
            triggerEvent(document.documentElement, "theme:loading:start");
        }
        hideLoadingBar() {
            triggerEvent(document.documentElement, "theme:loading:end");
        }
        untilVisible(e = { rootMargin: "30px 0px", threshold: 0 }) {
            let t = () => {
                this.classList.add("became-visible"), (this.style.opacity = "1");
            };
            return new Promise((i) => {
                window.IntersectionObserver
                    ? ((this.intersectionObserver = new IntersectionObserver((e) => {
                          e[0].isIntersecting &&
                              (this.intersectionObserver.disconnect(),
                              requestAnimationFrame(() => {
                                  i(), t();
                              }));
                      }, e)),
                      this.intersectionObserver.observe(this))
                    : (i(), t());
            });
        }
        disconnectedCallback() {
            this.delegate.destroy(), this.rootDelegate.destroy(), this.intersectionObserver?.disconnect(), delete this._delegate, delete this._rootDelegate;
        }
    },
    candidateSelectors = [
        "input:not([inert])",
        "select:not([inert])",
        "textarea:not([inert])",
        "a[href]:not([inert])",
        "button:not([inert])",
        "[tabindex]:not(slot):not([inert])",
        "audio[controls]:not([inert])",
        "video[controls]:not([inert])",
        '[contenteditable]:not([contenteditable="false"]):not([inert])',
        "details>summary:first-of-type:not([inert])",
        "details:not([inert])",
    ],
    candidateSelector = candidateSelectors.join(","),
    NoElement = "undefined" == typeof Element,
    matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
    getRootNode =
        !NoElement && Element.prototype.getRootNode
            ? function (e) {
                  var t;
                  return null == e || null === (t = e.getRootNode) || void 0 === t ? void 0 : t.call(e);
              }
            : function (e) {
                  return null == e ? void 0 : e.ownerDocument;
              },
    isInert = function e(t, i) {
        void 0 === i && (i = !0);
        var n,
            s = null == t || null === (n = t.getAttribute) || void 0 === n ? void 0 : n.call(t, "inert");
        return "" === s || "true" === s || (i && t && e(t.parentNode));
    },
    isContentEditable = function (e) {
        var t,
            i = null == e || null === (t = e.getAttribute) || void 0 === t ? void 0 : t.call(e, "contenteditable");
        return "" === i || "true" === i;
    },
    getCandidates = function (e, t, i) {
        if (isInert(e)) return [];
        var n = Array.prototype.slice.apply(e.querySelectorAll(candidateSelector));
        return t && matches.call(e, candidateSelector) && n.unshift(e), n.filter(i);
    },
    getCandidatesIteratively = function e(t, i, n) {
        for (var s = [], a = Array.from(t); a.length; ) {
            var r = a.shift();
            if (!isInert(r, !1))
                if ("SLOT" === r.tagName) {
                    var o = r.assignedElements(),
                        l = e(o.length ? o : r.children, !0, n);
                    n.flatten ? s.push.apply(s, l) : s.push({ scopeParent: r, candidates: l });
                } else {
                    matches.call(r, candidateSelector) && n.filter(r) && (i || !t.includes(r)) && s.push(r);
                    var d = r.shadowRoot || ("function" == typeof n.getShadowRoot && n.getShadowRoot(r)),
                        c = !isInert(d, !1) && (!n.shadowRootFilter || n.shadowRootFilter(r));
                    if (d && c) {
                        var h = e(!0 === d ? r.children : d.children, !0, n);
                        n.flatten ? s.push.apply(s, h) : s.push({ scopeParent: r, candidates: h });
                    } else a.unshift.apply(a, r.children);
                }
        }
        return s;
    },
    hasTabIndex = function (e) {
        return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
    },
    getTabIndex = function (e) {
        if (!e) throw Error("No node provided");
        return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || isContentEditable(e)) && !hasTabIndex(e) ? 0 : e.tabIndex;
    },
    getSortOrderTabIndex = function (e, t) {
        var i = getTabIndex(e);
        return i < 0 && t && !hasTabIndex(e) ? 0 : i;
    },
    sortOrderedTabbables = function (e, t) {
        return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
    },
    isInput = function (e) {
        return "INPUT" === e.tagName;
    },
    isHiddenInput = function (e) {
        return isInput(e) && "hidden" === e.type;
    },
    isDetailsWithSummary = function (e) {
        return (
            "DETAILS" === e.tagName &&
            Array.prototype.slice.apply(e.children).some(function (e) {
                return "SUMMARY" === e.tagName;
            })
        );
    },
    getCheckedRadio = function (e, t) {
        for (var i = 0; i < e.length; i++) if (e[i].checked && e[i].form === t) return e[i];
    },
    isTabbableRadio = function (e) {
        if (!e.name) return !0;
        var t,
            i = e.form || getRootNode(e),
            n = function (e) {
                return i.querySelectorAll('input[type="radio"][name="' + e + '"]');
            };
        if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = n(window.CSS.escape(e.name));
        else
            try {
                t = n(e.name);
            } catch (e) {
                return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
            }
        var s = getCheckedRadio(t, e.form);
        return !s || s === e;
    },
    isRadio = function (e) {
        return isInput(e) && "radio" === e.type;
    },
    isNonTabbableRadio = function (e) {
        return isRadio(e) && !isTabbableRadio(e);
    },
    isNodeAttached = function (e) {
        var t,
            i,
            n,
            s,
            a,
            r,
            o,
            l = e && getRootNode(e),
            d = null === (s = l) || void 0 === s ? void 0 : s.host,
            c = !1;
        if (l && l !== e)
            for (c = !!((null !== (a = d) && void 0 !== a && null !== (r = a.ownerDocument) && void 0 !== r && r.contains(d)) || (null != e && null !== (o = e.ownerDocument) && void 0 !== o && o.contains(e))); !c && d; )
                c = !(null === (i = d = null === (t = l = getRootNode(d)) || void 0 === t ? void 0 : t.host) || void 0 === i || null === (n = i.ownerDocument) || void 0 === n || !n.contains(d));
        return c;
    },
    isZeroArea = function (e) {
        var t = e.getBoundingClientRect(),
            i = t.width,
            n = t.height;
        return 0 === i && 0 === n;
    },
    isHidden = function (e, t) {
        var i = t.displayCheck,
            n = t.getShadowRoot;
        if ("hidden" === getComputedStyle(e).visibility) return !0;
        var s = matches.call(e, "details>summary:first-of-type") ? e.parentElement : e;
        if (matches.call(s, "details:not([open]) *")) return !0;
        if (i && "full" !== i && "legacy-full" !== i) {
            if ("non-zero-area" === i) return isZeroArea(e);
        } else {
            if ("function" == typeof n) {
                for (var a = e; e; ) {
                    var r = e.parentElement,
                        o = getRootNode(e);
                    if (r && !r.shadowRoot && !0 === n(r)) return isZeroArea(e);
                    e = e.assignedSlot ? e.assignedSlot : r || o === e.ownerDocument ? r : o.host;
                }
                e = a;
            }
            if (isNodeAttached(e)) return !e.getClientRects().length;
            if ("legacy-full" !== i) return !0;
        }
        return !1;
    },
    isDisabledFromFieldset = function (e) {
        if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
            for (var t = e.parentElement; t; ) {
                if ("FIELDSET" === t.tagName && t.disabled) {
                    for (var i = 0; i < t.children.length; i++) {
                        var n = t.children.item(i);
                        if ("LEGEND" === n.tagName) return !!matches.call(t, "fieldset[disabled] *") || !n.contains(e);
                    }
                    return !0;
                }
                t = t.parentElement;
            }
        return !1;
    },
    isNodeMatchingSelectorFocusable = function (e, t) {
        return !(t.disabled || isInert(t) || isHiddenInput(t) || isHidden(t, e) || isDetailsWithSummary(t) || isDisabledFromFieldset(t));
    },
    isNodeMatchingSelectorTabbable = function (e, t) {
        return !(isNonTabbableRadio(t) || 0 > getTabIndex(t) || !isNodeMatchingSelectorFocusable(e, t));
    },
    isValidShadowRootTabbable = function (e) {
        var t = parseInt(e.getAttribute("tabindex"), 10);
        return !!(isNaN(t) || t >= 0);
    },
    sortByOrder = function e(t) {
        var i = [],
            n = [];
        return (
            t.forEach(function (t, s) {
                var a = !!t.scopeParent,
                    r = a ? t.scopeParent : t,
                    o = getSortOrderTabIndex(r, a),
                    l = a ? e(t.candidates) : r;
                0 === o ? (a ? i.push.apply(i, l) : i.push(r)) : n.push({ documentOrder: s, tabIndex: o, item: t, isScope: a, content: l });
            }),
            n
                .sort(sortOrderedTabbables)
                .reduce(function (e, t) {
                    return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
                }, [])
                .concat(i)
        );
    },
    tabbable = function (e, t) {
        var i;
        return (
            (i = (t = t || {}).getShadowRoot
                ? getCandidatesIteratively([e], t.includeContainer, { filter: isNodeMatchingSelectorTabbable.bind(null, t), flatten: !1, getShadowRoot: t.getShadowRoot, shadowRootFilter: isValidShadowRootTabbable })
                : getCandidates(e, t.includeContainer, isNodeMatchingSelectorTabbable.bind(null, t))),
            sortByOrder(i)
        );
    },
    focusable = function (e, t) {
        return (t = t || {}).getShadowRoot
            ? getCandidatesIteratively([e], t.includeContainer, { filter: isNodeMatchingSelectorFocusable.bind(null, t), flatten: !0, getShadowRoot: t.getShadowRoot })
            : getCandidates(e, t.includeContainer, isNodeMatchingSelectorFocusable.bind(null, t));
    },
    isTabbable = function (e, t) {
        if (((t = t || {}), !e)) throw Error("No node provided");
        return !1 !== matches.call(e, candidateSelector) && isNodeMatchingSelectorTabbable(t, e);
    },
    focusableCandidateSelector = candidateSelectors.concat("iframe").join(","),
    isFocusable = function (e, t) {
        if (((t = t || {}), !e)) throw Error("No node provided");
        return !1 !== matches.call(e, focusableCandidateSelector) && isNodeMatchingSelectorFocusable(t, e);
    };
function ownKeys(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
            (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            i.push.apply(i, n);
    }
    return i;
}
function _objectSpread2(e) {
    for (var t = 1; t < arguments.length; t++) {
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2
            ? ownKeys(Object(i), !0).forEach(function (t) {
                  _defineProperty(e, t, i[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
            : ownKeys(Object(i)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
              });
    }
    return e;
}
function _defineProperty(e, t, i) {
    return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = i), e;
}
function _toPrimitive(e, t) {
    if ("object" != typeof e || null === e) return e;
    var i = e[Symbol.toPrimitive];
    if (void 0 !== i) {
        var n = i.call(e, t || "default");
        if ("object" != typeof n) return n;
        throw TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
}
function _toPropertyKey(e) {
    var t = _toPrimitive(e, "string");
    return "symbol" == typeof t ? t : String(t);
}
var activeFocusTraps = {
        activateTrap: function (e, t) {
            if (e.length > 0) {
                var i = e[e.length - 1];
                i !== t && i.pause();
            }
            var n = e.indexOf(t);
            -1 === n || e.splice(n, 1), e.push(t);
        },
        deactivateTrap: function (e, t) {
            var i = e.indexOf(t);
            -1 !== i && e.splice(i, 1), e.length > 0 && e[e.length - 1].unpause();
        },
    },
    isSelectableInput = function (e) {
        return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
    },
    isEscapeEvent = function (e) {
        return "Escape" === (null == e ? void 0 : e.key) || "Esc" === (null == e ? void 0 : e.key) || 27 === (null == e ? void 0 : e.keyCode);
    },
    isTabEvent = function (e) {
        return "Tab" === (null == e ? void 0 : e.key) || 9 === (null == e ? void 0 : e.keyCode);
    },
    isKeyForward = function (e) {
        return isTabEvent(e) && !e.shiftKey;
    },
    isKeyBackward = function (e) {
        return isTabEvent(e) && e.shiftKey;
    },
    delay = function (e) {
        return setTimeout(e, 0);
    },
    findIndex = function (e, t) {
        var i = -1;
        return (
            e.every(function (e, n) {
                return !t(e) || ((i = n), !1);
            }),
            i
        );
    },
    valueOrHandler = function (e) {
        for (var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) i[n - 1] = arguments[n];
        return "function" == typeof e ? e.apply(void 0, i) : e;
    },
    getActualTarget = function (e) {
        return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
    },
    internalTrapStack = [],
    createFocusTrap = function (e, t) {
        var i,
            n = (null == t ? void 0 : t.document) || document,
            s = (null == t ? void 0 : t.trapStack) || internalTrapStack,
            a = _objectSpread2({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0, isKeyForward: isKeyForward, isKeyBackward: isKeyBackward }, t),
            r = { containers: [], containerGroups: [], tabbableGroups: [], nodeFocusedBeforeActivation: null, mostRecentlyFocusedNode: null, active: !1, paused: !1, delayInitialFocusTimer: void 0, recentNavEvent: void 0 },
            o = function (e, t, i) {
                return e && void 0 !== e[t] ? e[t] : a[i || t];
            },
            l = function (e, t) {
                var i = "function" == typeof (null == t ? void 0 : t.composedPath) ? t.composedPath() : void 0;
                return r.containerGroups.findIndex(function (t) {
                    var n = t.container,
                        s = t.tabbableNodes;
                    return (
                        n.contains(e) ||
                        (null == i ? void 0 : i.includes(n)) ||
                        s.find(function (t) {
                            return t === e;
                        })
                    );
                });
            },
            d = function (e) {
                var t = a[e];
                if ("function" == typeof t) {
                    for (var i = arguments.length, s = Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) s[r - 1] = arguments[r];
                    t = t.apply(void 0, s);
                }
                if ((!0 === t && (t = void 0), !t)) {
                    if (void 0 === t || !1 === t) return t;
                    throw Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
                }
                var o = t;
                if ("string" == typeof t && !(o = n.querySelector(t))) throw Error("`".concat(e, "` as selector refers to no known node"));
                return o;
            },
            c = function () {
                var e = d("initialFocus");
                if (!1 === e) return !1;
                if (void 0 === e || !isFocusable(e, a.tabbableOptions))
                    if (l(n.activeElement) >= 0) e = n.activeElement;
                    else {
                        var t = r.tabbableGroups[0];
                        e = (t && t.firstTabbableNode) || d("fallbackFocus");
                    }
                if (!e) throw Error("Your focus-trap needs to have at least one focusable element");
                return e;
            },
            h = function () {
                if (
                    ((r.containerGroups = r.containers.map(function (e) {
                        var t = tabbable(e, a.tabbableOptions),
                            i = focusable(e, a.tabbableOptions),
                            n = t.length > 0 ? t[0] : void 0,
                            s = t.length > 0 ? t[t.length - 1] : void 0,
                            r = i.find(function (e) {
                                return isTabbable(e);
                            }),
                            o = i
                                .slice()
                                .reverse()
                                .find(function (e) {
                                    return isTabbable(e);
                                }),
                            l = !!t.find(function (e) {
                                return getTabIndex(e) > 0;
                            });
                        return {
                            container: e,
                            tabbableNodes: t,
                            focusableNodes: i,
                            posTabIndexesFound: l,
                            firstTabbableNode: n,
                            lastTabbableNode: s,
                            firstDomTabbableNode: r,
                            lastDomTabbableNode: o,
                            nextTabbableNode: function (e) {
                                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                                    s = t.indexOf(e);
                                return s < 0
                                    ? n
                                        ? i.slice(i.indexOf(e) + 1).find(function (e) {
                                              return isTabbable(e);
                                          })
                                        : i
                                              .slice(0, i.indexOf(e))
                                              .reverse()
                                              .find(function (e) {
                                                  return isTabbable(e);
                                              })
                                    : t[s + (n ? 1 : -1)];
                            },
                        };
                    })),
                    (r.tabbableGroups = r.containerGroups.filter(function (e) {
                        return e.tabbableNodes.length > 0;
                    })),
                    r.tabbableGroups.length <= 0 && !d("fallbackFocus"))
                )
                    throw Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
                if (
                    r.containerGroups.find(function (e) {
                        return e.posTabIndexesFound;
                    }) &&
                    r.containerGroups.length > 1
                )
                    throw Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
            },
            u = function e(t) {
                var i = t.activeElement;
                if (i) return i.shadowRoot && null !== i.shadowRoot.activeElement ? e(i.shadowRoot) : i;
            },
            m = function e(t) {
                !1 !== t && t !== u(document) && (t && t.focus ? (t.focus({ preventScroll: !!a.preventScroll }), (r.mostRecentlyFocusedNode = t), isSelectableInput(t) && t.select()) : e(c()));
            },
            p = function (e) {
                var t = d("setReturnFocus", e);
                return t || (!1 !== t && e);
            },
            b = function (e) {
                var t = e.target,
                    i = e.event,
                    n = e.isBackward,
                    s = void 0 !== n && n;
                (t = t || getActualTarget(i)), h();
                var o = null;
                if (r.tabbableGroups.length > 0) {
                    var c = l(t, i),
                        u = c >= 0 ? r.containerGroups[c] : void 0;
                    if (c < 0) o = s ? r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : r.tabbableGroups[0].firstTabbableNode;
                    else if (s) {
                        var m = findIndex(r.tabbableGroups, function (e) {
                            return t === e.firstTabbableNode;
                        });
                        if ((m < 0 && (u.container === t || (isFocusable(t, a.tabbableOptions) && !isTabbable(t, a.tabbableOptions) && !u.nextTabbableNode(t, !1))) && (m = c), m >= 0)) {
                            var p = 0 === m ? r.tabbableGroups.length - 1 : m - 1,
                                b = r.tabbableGroups[p];
                            o = getTabIndex(t) >= 0 ? b.lastTabbableNode : b.lastDomTabbableNode;
                        } else isTabEvent(i) || (o = u.nextTabbableNode(t, !1));
                    } else {
                        var f = findIndex(r.tabbableGroups, function (e) {
                            return t === e.lastTabbableNode;
                        });
                        if ((f < 0 && (u.container === t || (isFocusable(t, a.tabbableOptions) && !isTabbable(t, a.tabbableOptions) && !u.nextTabbableNode(t))) && (f = c), f >= 0)) {
                            var g = f === r.tabbableGroups.length - 1 ? 0 : f + 1,
                                v = r.tabbableGroups[g];
                            o = getTabIndex(t) >= 0 ? v.firstTabbableNode : v.firstDomTabbableNode;
                        } else isTabEvent(i) || (o = u.nextTabbableNode(t));
                    }
                } else o = d("fallbackFocus");
                return o;
            },
            f = function (e) {
                var t = getActualTarget(e);
                l(t, e) >= 0 || (valueOrHandler(a.clickOutsideDeactivates, e) ? i.deactivate({ returnFocus: a.returnFocusOnDeactivate }) : valueOrHandler(a.allowOutsideClick, e) || e.preventDefault());
            },
            g = function (e) {
                var t = getActualTarget(e),
                    i = l(t, e) >= 0;
                if (i || t instanceof Document) i && (r.mostRecentlyFocusedNode = t);
                else {
                    e.stopImmediatePropagation();
                    var n,
                        s = !0;
                    if (r.mostRecentlyFocusedNode)
                        if (getTabIndex(r.mostRecentlyFocusedNode) > 0) {
                            var o = l(r.mostRecentlyFocusedNode),
                                d = r.containerGroups[o].tabbableNodes;
                            if (d.length > 0) {
                                var h = d.findIndex(function (e) {
                                    return e === r.mostRecentlyFocusedNode;
                                });
                                h >= 0 && (a.isKeyForward(r.recentNavEvent) ? h + 1 < d.length && ((n = d[h + 1]), (s = !1)) : h - 1 >= 0 && ((n = d[h - 1]), (s = !1)));
                            }
                        } else
                            r.containerGroups.some(function (e) {
                                return e.tabbableNodes.some(function (e) {
                                    return getTabIndex(e) > 0;
                                });
                            }) || (s = !1);
                    else s = !1;
                    s && (n = b({ target: r.mostRecentlyFocusedNode, isBackward: a.isKeyBackward(r.recentNavEvent) })), m(n || r.mostRecentlyFocusedNode || c());
                }
                r.recentNavEvent = void 0;
            },
            v = function (e) {
                if (isEscapeEvent(e) && !1 !== valueOrHandler(a.escapeDeactivates, e)) return e.preventDefault(), void i.deactivate();
                (a.isKeyForward(e) || a.isKeyBackward(e)) &&
                    (function (e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        r.recentNavEvent = e;
                        var i = b({ event: e, isBackward: t });
                        i && (isTabEvent(e) && e.preventDefault(), m(i));
                    })(e, a.isKeyBackward(e));
            },
            y = function (e) {
                var t = getActualTarget(e);
                l(t, e) >= 0 || valueOrHandler(a.clickOutsideDeactivates, e) || valueOrHandler(a.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
            },
            w = function () {
                if (r.active)
                    return (
                        activeFocusTraps.activateTrap(s, i),
                        (r.delayInitialFocusTimer = a.delayInitialFocus
                            ? delay(function () {
                                  m(c());
                              })
                            : m(c())),
                        n.addEventListener("focusin", g, !0),
                        n.addEventListener("mousedown", f, { capture: !0, passive: !1 }),
                        n.addEventListener("touchstart", f, { capture: !0, passive: !1 }),
                        n.addEventListener("click", y, { capture: !0, passive: !1 }),
                        n.addEventListener("keydown", v, { capture: !0, passive: !1 }),
                        i
                    );
            },
            _ = function () {
                if (r.active)
                    return n.removeEventListener("focusin", g, !0), n.removeEventListener("mousedown", f, !0), n.removeEventListener("touchstart", f, !0), n.removeEventListener("click", y, !0), n.removeEventListener("keydown", v, !0), i;
            },
            E =
                "undefined" != typeof window && "MutationObserver" in window
                    ? new MutationObserver(function (e) {
                          e.some(function (e) {
                              return Array.from(e.removedNodes).some(function (e) {
                                  return e === r.mostRecentlyFocusedNode;
                              });
                          }) && m(c());
                      })
                    : void 0,
            C = function () {
                E &&
                    (E.disconnect(),
                    r.active &&
                        !r.paused &&
                        r.containers.map(function (e) {
                            E.observe(e, { subtree: !0, childList: !0 });
                        }));
            };
        return (
            (i = {
                get active() {
                    return r.active;
                },
                get paused() {
                    return r.paused;
                },
                activate: function (e) {
                    if (r.active) return this;
                    var t = o(e, "onActivate"),
                        i = o(e, "onPostActivate"),
                        s = o(e, "checkCanFocusTrap");
                    s || h(), (r.active = !0), (r.paused = !1), (r.nodeFocusedBeforeActivation = n.activeElement), null == t || t();
                    var a = function () {
                        s && h(), w(), C(), null == i || i();
                    };
                    return s ? (s(r.containers.concat()).then(a, a), this) : (a(), this);
                },
                deactivate: function (e) {
                    if (!r.active) return this;
                    var t = _objectSpread2({ onDeactivate: a.onDeactivate, onPostDeactivate: a.onPostDeactivate, checkCanReturnFocus: a.checkCanReturnFocus }, e);
                    clearTimeout(r.delayInitialFocusTimer), (r.delayInitialFocusTimer = void 0), _(), (r.active = !1), (r.paused = !1), C(), activeFocusTraps.deactivateTrap(s, i);
                    var n = o(t, "onDeactivate"),
                        l = o(t, "onPostDeactivate"),
                        d = o(t, "checkCanReturnFocus"),
                        c = o(t, "returnFocus", "returnFocusOnDeactivate");
                    null == n || n();
                    var h = function () {
                        delay(function () {
                            c && m(p(r.nodeFocusedBeforeActivation)), null == l || l();
                        });
                    };
                    return c && d ? (d(p(r.nodeFocusedBeforeActivation)).then(h, h), this) : (h(), this);
                },
                pause: function (e) {
                    if (r.paused || !r.active) return this;
                    var t = o(e, "onPause"),
                        i = o(e, "onPostPause");
                    return (r.paused = !0), null == t || t(), _(), C(), null == i || i(), this;
                },
                unpause: function (e) {
                    if (!r.paused || !r.active) return this;
                    var t = o(e, "onUnpause"),
                        i = o(e, "onPostUnpause");
                    return (r.paused = !1), null == t || t(), h(), w(), C(), null == i || i(), this;
                },
                updateContainerElements: function (e) {
                    var t = [].concat(e).filter(Boolean);
                    return (
                        (r.containers = t.map(function (e) {
                            return "string" == typeof e ? n.querySelector(e) : e;
                        })),
                        r.active && h(),
                        C(),
                        this
                    );
                },
            }).updateContainerElements(e),
            i
        );
    };
function filterShopifyEvent(e, t, i) {
    let n = !1;
    e.type.includes("shopify:section") ? t.hasAttribute("section") && t.getAttribute("section") === e.detail.sectionId && (n = !0) : e.type.includes("shopify:block") && e.target === t && (n = !0), n && i(e);
}
var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
        return ["open"];
    }
    constructor() {
        if (
            (super(),
            Shopify.designMode &&
                (this.rootDelegate.on("shopify:section:select", (e) => filterShopifyEvent(e, this, () => (this.open = !0))), this.rootDelegate.on("shopify:section:deselect", (e) => filterShopifyEvent(e, this, () => (this.open = !1)))),
            this.hasAttribute("append-body"))
        ) {
            let e = document.getElementById(this.id);
            this.removeAttribute("append-body"), e && e !== this ? (e.replaceWith(this.cloneNode(!0)), this.remove()) : document.body.appendChild(this);
        }
    }
    connectedCallback() {
        this.delegate.on("click", ".openable__overlay", () => (this.open = !1)),
            this.delegate.on("click", '[data-action="close"]', (e) => {
                e.stopPropagation(), (this.open = !1);
            });
    }
    get requiresLoading() {
        return this.hasAttribute("href");
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        e
            ? (async () => {
                  await this._load(), this.clientWidth, this.setAttribute("open", "");
              })()
            : this.removeAttribute("open");
    }
    get shouldTrapFocus() {
        return !0;
    }
    get returnFocusOnDeactivate() {
        return !this.hasAttribute("return-focus") || "true" === this.getAttribute("return-focus");
    }
    get focusTrap() {
        return (this._focusTrap =
            this._focusTrap ||
            createFocusTrap(this, {
                fallbackFocus: this,
                initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
                clickOutsideDeactivates: (e) => !(e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id),
                allowOutsideClick: (e) => e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id,
                returnFocusOnDeactivate: this.returnFocusOnDeactivate,
                onDeactivate: () => (this.open = !1),
                preventScroll: !0,
            }));
    }
    attributeChangedCallback(e, t, i) {
        "open" === e &&
            (null === t && "" === i
                ? (this.shouldTrapFocus && setTimeout(() => this.focusTrap.activate(), 150), triggerEvent(this, "openable-element:open"))
                : null === i && (this.shouldTrapFocus && this.focusTrap.deactivate(), triggerEvent(this, "openable-element:close")));
    }
    async _load() {
        if (!this.requiresLoading) return;
        triggerNonBubblingEvent(this, "openable-element:load:start");
        let e = await fetch(this.getAttribute("href")),
            t = document.createElement("div");
        (t.innerHTML = await e.text()), (this.innerHTML = t.querySelector(this.tagName.toLowerCase()).innerHTML), this.removeAttribute("href"), triggerNonBubblingEvent(this, "openable-element:load:end");
    }
};
window.customElements.define("openable-element", OpenableElement);
var CollapsibleContent = class extends OpenableElement {
    constructor() {
        super(), (this.ignoreNextTransition = this.open), this.addEventListener("shopify:block:select", () => (this.open = !0)), this.addEventListener("shopify:block:deselect", () => (this.open = !1));
    }
    get animateItems() {
        return this.hasAttribute("animate-items");
    }
    attributeChangedCallback(e) {
        if (this.ignoreNextTransition) return (this.ignoreNextTransition = !1);
        if ("open" === e) {
            this.style.overflow = "hidden";
            let e = { height: ["0px", `${this.scrollHeight}px`], visibility: ["hidden", "visible"] };
            this.animateItems && (e.opacity = this.open ? [0, 0] : [0, 1]),
                (this.animate(e, { duration: 500, direction: this.open ? "normal" : "reverse", easing: "cubic-bezier(0.75, 0, 0.175, 1)" }).onfinish = () => {
                    this.style.overflow = this.open ? "visible" : "hidden";
                }),
                this.animateItems && this.open && this.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 250, delay: 250, easing: "cubic-bezier(0.75, 0, 0.175, 1)" }),
                triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close");
        }
    }
};
window.customElements.define("collapsible-content", CollapsibleContent);
var ConfirmButton = class extends HTMLButtonElement {
    connectedCallback() {
        this.addEventListener("click", (e) => {
            window.confirm(this.getAttribute("data-message") || "Are you sure you wish to do this?") || e.preventDefault();
        });
    }
};
window.customElements.define("confirm-button", ConfirmButton, { extends: "button" });
var LoaderButtonMixin = {
        _prepareButton() {
            (this.originalContent = this.innerHTML),
                (this._startTransitionPromise = null),
                (this.innerHTML = `\n      <span class="loader-button__text">${this.innerHTML}</span>\n      <span class="loader-button__loader" hidden>\n        <div class="spinner">\n          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">\n            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>\n          </svg>\n        </div>\n      </span>\n    `),
                (this.textElement = this.firstElementChild),
                (this.spinnerElement = this.lastElementChild),
                window.addEventListener("pagehide", () => this.removeAttribute("aria-busy"));
        },
        _startTransition() {
            let e = this.textElement.animate({ opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 75, easing: "ease", fill: "forwards" });
            this.spinnerElement.hidden = !1;
            let t = this.spinnerElement.animate({ opacity: [0, 1], transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"] }, { duration: 75, delay: 75, easing: "ease", fill: "forwards" });
            this._startTransitionPromise = Promise.all([new Promise((t) => (e.onfinish = () => t())), new Promise((e) => (t.onfinish = () => e()))]);
        },
        async _endTransition() {
            this._startTransitionPromise &&
                (await this._startTransitionPromise,
                (this.spinnerElement.animate({ opacity: [1, 0], transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"] }, { duration: 75, delay: 100, easing: "ease", fill: "forwards" }).onfinish = () =>
                    (this.spinnerElement.hidden = !0)),
                this.textElement.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 75, delay: 175, easing: "ease", fill: "forwards" }),
                (this._startTransitionPromise = null));
        },
    },
    LoaderButton = class extends HTMLButtonElement {
        static get observedAttributes() {
            return ["aria-busy"];
        }
        constructor() {
            super(),
                this.addEventListener("click", (e) => {
                    "submit" === this.type &&
                        this.form &&
                        this.form.checkValidity() &&
                        !this.form.hasAttribute("is") &&
                        (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (e.preventDefault(), this.setAttribute("aria-busy", "true"), setTimeout(() => this.form.submit(), 250)) : this.setAttribute("aria-busy", "true"));
                });
        }
        connectedCallback() {
            this._prepareButton();
        }
        disconnectedCallback() {
            this.innerHTML = this.originalContent;
        }
        attributeChangedCallback(e, t, i) {
            "aria-busy" === e && ("true" === i ? this._startTransition() : this._endTransition());
        }
    };
Object.assign(LoaderButton.prototype, LoaderButtonMixin), window.customElements.define("loader-button", LoaderButton, { extends: "button" });
var PagePagination = class extends CustomHTMLElement {
    connectedCallback() {
        this.hasAttribute("ajax") && this.delegate.on("click", "a", this._onLinkClicked.bind(this));
    }
    _onLinkClicked(e, t) {
        e.preventDefault();
        let i = new URL(window.location.href);
        i.searchParams.set("page", t.getAttribute("data-page")), triggerEvent(this, "pagination:page-changed", { url: i.toString() });
    }
};
window.customElements.define("page-pagination", PagePagination);
var ToggleButton = class extends HTMLButtonElement {
    static get observedAttributes() {
        return ["aria-expanded", "aria-busy"];
    }
    constructor() {
        super(), this.hasAttribute("loader") && this._prepareButton(), this.addEventListener("click", this._onButtonClick.bind(this)), (this.rootDelegate = new main_default(document.documentElement));
    }
    _onButtonClick() {
        this.isExpanded = !this.isExpanded;
    }
    connectedCallback() {
        document.addEventListener("openable-element:close", (e) => {
            this.controlledElement === e.target && ((this.isExpanded = !1), e.stopPropagation());
        }),
            document.addEventListener("openable-element:open", (e) => {
                this.controlledElement === e.target && ((this.isExpanded = !0), e.stopPropagation());
            }),
            this.rootDelegate.on(
                "openable-element:load:start",
                `#${this.getAttribute("aria-controls")}`,
                () => {
                    this.classList.contains("button") ? this.setAttribute("aria-busy", "true") : null !== this.offsetParent && triggerEvent(document.documentElement, "theme:loading:start");
                },
                !0
            ),
            this.rootDelegate.on(
                "openable-element:load:end",
                `#${this.getAttribute("aria-controls")}`,
                () => {
                    this.classList.contains("button") ? this.removeAttribute("aria-busy") : null !== this.offsetParent && triggerEvent(document.documentElement, "theme:loading:end");
                },
                !0
            );
    }
    disconnectedCallback() {
        this.rootDelegate.destroy();
    }
    get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
    }
    set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
    }
    get controlledElement() {
        return document.getElementById(this.getAttribute("aria-controls"));
    }
    attributeChangedCallback(e, t, i) {
        switch (e) {
            case "aria-expanded":
                "false" === t && "true" === i ? (this.controlledElement.open = !0) : "true" === t && "false" === i && (this.controlledElement.open = !1);
                break;
            case "aria-busy":
                this.hasAttribute("loader") && ("true" === i ? this._startTransition() : this._endTransition());
        }
    }
};
Object.assign(ToggleButton.prototype, LoaderButtonMixin), window.customElements.define("toggle-button", ToggleButton, { extends: "button" });
var ToggleLink = class extends HTMLAnchorElement {
    static get observedAttributes() {
        return ["aria-expanded"];
    }
    constructor() {
        super(),
            this.addEventListener("click", (e) => {
                e.preventDefault(), (this.isExpanded = !this.isExpanded);
            }),
            (this.rootDelegate = new main_default(document.documentElement));
    }
    connectedCallback() {
        this.rootDelegate.on(
            "openable-element:close",
            `#${this.getAttribute("aria-controls")}`,
            (e) => {
                this.controlledElement === e.target && (this.isExpanded = !1);
            },
            !0
        ),
            this.rootDelegate.on(
                "openable-element:open",
                `#${this.getAttribute("aria-controls")}`,
                (e) => {
                    this.controlledElement === e.target && (this.isExpanded = !0);
                },
                !0
            );
    }
    disconnectedCallback() {
        this.rootDelegate.destroy();
    }
    get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
    }
    set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
    }
    get controlledElement() {
        return document.querySelector(`#${this.getAttribute("aria-controls")}`);
    }
    attributeChangedCallback(e, t, i) {
        "aria-expanded" === e && ("false" === t && "true" === i ? (this.controlledElement.open = !0) : "true" === t && "false" === i && (this.controlledElement.open = !1));
    }
};
window.customElements.define("toggle-link", ToggleLink, { extends: "a" });
var PageDots = class extends CustomHTMLElement {
    connectedCallback() {
        (this.buttons = Array.from(this.querySelectorAll("button"))),
            this.delegate.on("click", "button", (e, t) => {
                this._dispatchEvent(this.buttons.indexOf(t));
            }),
            this.hasAttribute("animation-timer") &&
                this.delegate.on("animationend", (e) => {
                    e.elapsedTime > 0 && this._dispatchEvent((this.selectedIndex + 1 + this.buttons.length) % this.buttons.length);
                });
    }
    get selectedIndex() {
        return this.buttons.findIndex((e) => "true" === e.getAttribute("aria-current"));
    }
    set selectedIndex(e) {
        if ((this.buttons.forEach((t, i) => t.setAttribute("aria-current", e === i ? "true" : "false")), this.hasAttribute("align-selected"))) {
            let t = this.buttons[e],
                i = window.innerWidth / 2,
                n = t.getBoundingClientRect(),
                s = this._findFirstScrollableElement(this.parentElement);
            s && s.scrollTo({ behavior: "smooth", left: s.scrollLeft + (n.left - i) + n.width / 2 });
        }
    }
    _dispatchEvent(e) {
        e !== this.selectedIndex && this.dispatchEvent(new CustomEvent("page-dots:changed", { bubbles: !0, detail: { index: e } }));
    }
    _findFirstScrollableElement(e, t = 0) {
        return null === e || t > 3 ? null : e.scrollWidth > e.clientWidth ? e : this._findFirstScrollableElement(e.parentElement, t + 1);
    }
};
window.customElements.define("page-dots", PageDots);
var PrevNextButtons = class extends HTMLElement {
        connectedCallback() {
            (this.prevButton = this.querySelector("button:first-of-type")),
                (this.nextButton = this.querySelector("button:last-of-type")),
                this.prevButton.addEventListener("click", () => this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: !0 }))),
                this.nextButton.addEventListener("click", () => this.nextButton.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: !0 })));
        }
        set isPrevDisabled(e) {
            this.prevButton.disabled = e;
        }
        set isNextDisabled(e) {
            this.nextButton.disabled = e;
        }
    },
    PrevButton = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: !0 })));
        }
    },
    NextButton = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: !0 })));
        }
    };
function getStickyHeaderOffset() {
    let e = getComputedStyle(document.documentElement);
    return (
        parseInt(e.getPropertyValue("--header-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-header") || 0) +
        parseInt(e.getPropertyValue("--announcement-bar-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-announcement-bar") || 0)
    );
}
window.customElements.define("prev-next-buttons", PrevNextButtons), window.customElements.define("prev-button", PrevButton, { extends: "button" }), window.customElements.define("next-button", NextButton, { extends: "button" });
var SafeSticky = class extends HTMLElement {
    connectedCallback() {
        (this.lastKnownY = window.scrollY), (this.currentTop = 0), (this.hasPendingRaf = !1), window.addEventListener("scroll", this._checkPosition.bind(this));
    }
    get initialTopOffset() {
        return getStickyHeaderOffset() + (parseInt(this.getAttribute("offset")) || 0);
    }
    _checkPosition() {
        this.hasPendingRaf ||
            ((this.hasPendingRaf = !0),
            requestAnimationFrame(() => {
                let e = this.getBoundingClientRect().top + window.scrollY - this.offsetTop + this.initialTopOffset,
                    t = this.clientHeight - window.innerHeight;
                window.scrollY < this.lastKnownY ? (this.currentTop -= window.scrollY - this.lastKnownY) : (this.currentTop += this.lastKnownY - window.scrollY),
                    (this.currentTop = Math.min(Math.max(this.currentTop, -t), e, this.initialTopOffset)),
                    (this.lastKnownY = window.scrollY),
                    (this.style.top = `${this.currentTop}px`),
                    (this.hasPendingRaf = !1);
            }));
    }
};
function throttle(e, t = 15) {
    let i = null,
        n = null,
        s = (a) => {
            (n = a),
                i ||
                    (e(n),
                    (n = null),
                    (i = setTimeout(() => {
                        (i = null), n && s(n);
                    }, t)));
        };
    return s;
}
window.customElements.define("safe-sticky", SafeSticky);
var ScrollSpy = class extends HTMLElement {
    connectedCallback() {
        this._createSvg(),
            (this.elementsToObserve = Array.from(this.querySelectorAll("a")).map((e) => document.querySelector(e.getAttribute("href")))),
            (this.navListItems = Array.from(this.querySelectorAll("li"))),
            (this.navItems = this.navListItems
                .map((e) => {
                    let t = e.firstElementChild,
                        i = t && t.getAttribute("href").slice(1);
                    return { listItem: e, anchor: t, target: document.getElementById(i) };
                })
                .filter((e) => e.target)),
            this.drawPath(),
            window.addEventListener("scroll", throttle(this.markVisibleSection.bind(this), 25)),
            window.addEventListener("orientationchange", () => {
                window.addEventListener(
                    "resize",
                    () => {
                        this.drawPath(), this.markVisibleSection();
                    },
                    { once: !0 }
                );
            }),
            this.markVisibleSection();
    }
    _createSvg() {
        this.navPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
        let e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        e.insertAdjacentElement("beforeend", this.navPath), this.insertAdjacentElement("beforeend", e), (this.lastPathStart = this.lastPathEnd = null);
    }
    drawPath() {
        let e,
            t = [];
        this.navItems.forEach((i, n) => {
            let s = i.anchor.offsetLeft - 5,
                a = i.anchor.offsetTop,
                r = i.anchor.offsetHeight;
            0 === n
                ? (t.push("M", s, a, "L", s, a + r), (i.pathStart = 0))
                : (e !== s && t.push("L", e, a), t.push("L", s, a), this.navPath.setAttribute("d", t.join(" ")), (i.pathStart = this.navPath.getTotalLength() || 0), t.push("L", s, a + r)),
                (e = s),
                this.navPath.setAttribute("d", t.join(" ")),
                (i.pathEnd = this.navPath.getTotalLength());
        });
    }
    syncPath() {
        let e = this.navPath.getTotalLength(),
            t = e,
            i = 0;
        if (
            (this.navItems.forEach((e) => {
                e.listItem.classList.contains("is-visible") && ((t = Math.min(e.pathStart, t)), (i = Math.max(e.pathEnd, i)));
            }),
            this.querySelectorAll(".is-visible").length > 0 && t < i)
        ) {
            if (t !== this.lastPathStart || i !== this.lastPathEnd) {
                let n = `1 ${t} ${i - t} ${e}`;
                this.navPath.style.setProperty("stroke-dashoffset", "1"), this.navPath.style.setProperty("stroke-dasharray", n), this.navPath.style.setProperty("opacity", "1");
            }
        } else this.navPath.style.setProperty("opacity", "0");
        (this.lastPathStart = t), (this.lastPathEnd = i);
    }
    markVisibleSection() {
        for (let [e, t] of (this.navListItems.forEach((e) => e.classList.remove("is-visible")), this.elementsToObserve.entries()))
            if (t.getBoundingClientRect().top > getStickyHeaderOffset() || e === this.elementsToObserve.length - 1) {
                this.querySelector(`a[href="#${t.id}"]`).parentElement.classList.add("is-visible");
                break;
            }
        this.syncPath();
    }
};
window.customElements.define("scroll-spy", ScrollSpy);
var template =
        "\n  <style>\n    :host {\n      display: inline-block;\n      contain: layout;\n      position: relative;\n    }\n    \n    :host([hidden]) {\n      display: none;\n    }\n    \n    s {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      pointer-events: none;\n      background-image:\n        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));\n      background-position: top, bottom, left, right;\n      background-repeat: no-repeat;\n      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;\n    }\n  </style>\n  <slot></slot>\n  <s></s>\n",
    Updater = class {
        constructor(e) {
            (this.scheduleUpdate = throttle(() => this.update(e, getComputedStyle(e)))), (this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this)));
        }
        start(e) {
            this.element && this.stop(), e && (e.addEventListener("scroll", this.scheduleUpdate), this.resizeObserver.observe(e), (this.element = e));
        }
        stop() {
            this.element && (this.element.removeEventListener("scroll", this.scheduleUpdate), this.resizeObserver.unobserve(this.element), (this.element = null));
        }
        update(e, t) {
            if (!this.element) return;
            let i = t.getPropertyValue("--scroll-shadow-size") ? parseInt(t.getPropertyValue("--scroll-shadow-size")) : 0,
                n = {
                    top: Math.max(this.element.scrollTop, 0),
                    bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
                    left: Math.max(this.element.scrollLeft, 0),
                    right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0),
                };
            requestAnimationFrame(() => {
                for (let t of ["top", "bottom", "left", "right"]) e.style.setProperty(`--${t}`, `${n[t] > i ? i : n[t]}px`);
            });
        }
    },
    ScrollShadow = class extends HTMLElement {
        constructor() {
            super(), (this.attachShadow({ mode: "open" }).innerHTML = template), (this.updater = new Updater(this.shadowRoot.lastElementChild));
        }
        connectedCallback() {
            this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => this.start()), this.start();
        }
        disconnectedCallback() {
            this.updater.stop();
        }
        start() {
            this.updater.start(this.firstElementChild);
        }
    };
"ResizeObserver" in window && window.customElements.define("scroll-shadow", ScrollShadow);
var ShareToggleButton = class extends ToggleButton {
    _onButtonClick() {
        window.matchMedia(window.themeVariables.breakpoints.phone).matches && navigator.share
            ? navigator.share({ title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title, url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href })
            : super._onButtonClick();
    }
};
window.customElements.define("share-toggle-button", ShareToggleButton, { extends: "button" });
var NativeCarousel = class extends CustomHTMLElement {
        connectedCallback() {
            (this.items = Array.from(this.querySelectorAll("native-carousel-item"))),
                (this.pageDotsElements = Array.from(this.querySelectorAll("page-dots"))),
                (this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons"))),
                this.items.length > 1 &&
                    (this.addEventListener("prev-next:prev", this.prev.bind(this)),
                    this.addEventListener("prev-next:next", this.next.bind(this)),
                    this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index, !0)),
                    Shopify.designMode && this.addEventListener("shopify:block:select", (e) => this.select(e.target.index, !e.detail.load)));
            let e = this.items[0].parentElement;
            (this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this), { root: e, rootMargin: `${e.clientHeight}px 0px`, threshold: 0.8 })), this.items.forEach((e) => this.intersectionObserver.observe(e));
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this.intersectionObserver.disconnect();
        }
        get selectedIndex() {
            return this.items.findIndex((e) => e.selected);
        }
        prev(e = !0) {
            this.select(Math.max(this.selectedIndex - 1, 0), e);
        }
        next(e = !0) {
            this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), e);
        }
        select(e, t = !0) {
            let i = Math.max(0, Math.min(e, this.items.length)),
                n = this.items[i];
            this._adjustNavigationForElement(n),
                t &&
                    (this.items.forEach((e) => this.intersectionObserver.unobserve(e)),
                    setInterval(() => {
                        this.items.forEach((e) => this.intersectionObserver.observe(e));
                    }, 800)),
                this.items.forEach((e, t) => (e.selected = t === i));
            let s = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
            n.parentElement.scrollTo({ left: s * (n.clientWidth * i), behavior: t ? "smooth" : "auto" });
        }
        _adjustNavigationForElement(e) {
            this.items.forEach((t) => (t.selected = e === t)),
                this.pageDotsElements.forEach((t) => (t.selectedIndex = e.index)),
                this.prevNextButtonsElements.forEach((t) => {
                    (t.isPrevDisabled = 0 === e.index), (t.isNextDisabled = e.index === this.items.length - 1);
                });
        }
        _onVisibilityChanged(e) {
            for (let t of e)
                if (t.isIntersecting) {
                    this._adjustNavigationForElement(t.target);
                    break;
                }
        }
    },
    NativeCarouselItem = class extends CustomHTMLElement {
        static get observedAttributes() {
            return ["hidden"];
        }
        get index() {
            return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
            return !this.hasAttribute("hidden");
        }
        set selected(e) {
            this.hidden = !e;
        }
    };
window.customElements.define("native-carousel-item", NativeCarouselItem), window.customElements.define("native-carousel", NativeCarousel);
var DragCursor = class extends HTMLElement {
    connectedCallback() {
        (this.scrollableElement = this.parentElement),
            this.scrollableElement.addEventListener("mouseenter", this._onMouseEnter.bind(this)),
            this.scrollableElement.addEventListener("mousemove", this._onMouseMove.bind(this)),
            this.scrollableElement.addEventListener("mouseleave", this._onMouseLeave.bind(this)),
            (this.innerHTML =
                '\n      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">\n        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>\n        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>\n      </svg>\n    ');
    }
    _onMouseEnter(e) {
        this.removeAttribute("hidden"), this._positionCursor(e);
    }
    _onMouseLeave() {
        this.setAttribute("hidden", "");
    }
    _onMouseMove(e) {
        this.toggleAttribute("hidden", "BUTTON" === e.target.tagName || "A" === e.target.tagName), this._positionCursor(e);
    }
    _positionCursor(e) {
        let t = this.scrollableElement.getBoundingClientRect(),
            i = e.clientX - t.x,
            n = e.clientY - t.y;
        this.style.transform = `translate(${i - this.clientWidth / 2}px, ${n - this.clientHeight / 2}px)`;
    }
};
window.customElements.define("drag-cursor", DragCursor);
var ScrollableContent = class extends CustomHTMLElement {
    connectedCallback() {
        this.draggable && this._setupDraggability(), this._checkScrollability(), window.addEventListener("resize", this._checkScrollability.bind(this)), this.addEventListener("scroll", throttle(this._calculateProgress.bind(this), 15));
    }
    get draggable() {
        return this.hasAttribute("draggable");
    }
    _setupDraggability() {
        this.insertAdjacentHTML("afterend", '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>');
        let e = matchMedia("(hover: none)");
        e.addListener(this._onMediaChanges.bind(this)), e.matches || this._attachDraggableListeners();
    }
    _attachDraggableListeners() {
        this.delegate.on("mousedown", this._onMouseDown.bind(this)), this.delegate.on("mousemove", this._onMouseMove.bind(this)), this.delegate.on("mouseup", this._onMouseUp.bind(this));
    }
    _removeDraggableListeners() {
        this.delegate.off("mousedown"), this.delegate.off("mousemove"), this.delegate.off("mouseup");
    }
    _checkScrollability() {
        this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth);
    }
    _calculateProgress() {
        let e = this.scrollLeft * ("ltr" === window.themeVariables.settings.direction ? 1 : -1);
        triggerEvent(this, "scrollable-content:progress", { progress: 100 * Math.max(0, Math.min(1, e / (this.scrollWidth - this.clientWidth))) });
    }
    _onMediaChanges(e) {
        e.matches ? this._removeDraggableListeners() : this._attachDraggableListeners();
    }
    _onMouseDown(e) {
        e.target && "IMG" === e.target.nodeName && e.preventDefault(), (this.startX = e.clientX + this.scrollLeft), (this.diffX = 0), (this.drag = !0);
    }
    _onMouseMove(e) {
        this.drag && ((this.diffX = this.startX - (e.clientX + this.scrollLeft)), (this.scrollLeft += this.diffX));
    }
    _onMouseUp() {
        this.drag = !1;
        let e = 1,
            t = () => {
                let i = Math.sinh(e);
                i <= 0 ? window.cancelAnimationFrame(t) : ((this.scrollLeft += this.diffX * i), (e -= 0.03), window.requestAnimationFrame(t));
            };
        t();
    }
};
window.customElements.define("scrollable-content", ScrollableContent);
var LoadingBar = class extends CustomHTMLElement {
    constructor() {
        super(), this.rootDelegate.on("theme:loading:start", this.show.bind(this)), this.rootDelegate.on("theme:loading:end", this.hide.bind(this)), this.delegate.on("transitionend", this._onTransitionEnd.bind(this));
    }
    show() {
        this.classList.add("is-visible"), (this.style.transform = "scaleX(0.4)");
    }
    hide() {
        (this.style.transform = "scaleX(1)"), this.classList.add("is-finished");
    }
    _onTransitionEnd(e) {
        "transform" === e.propertyName && this.classList.contains("is-finished") && (this.classList.remove("is-visible"), this.classList.remove("is-finished"), (this.style.transform = "scaleX(0)"));
    }
};
window.customElements.define("loading-bar", LoadingBar);
var SplitLines = class extends HTMLElement {
    connectedCallback() {
        (this.originalContent = this.textContent), (this.lastWidth = window.innerWidth), (this.hasBeenSplitted = !1), window.addEventListener("resize", this._onResize.bind(this));
    }
    [Symbol.asyncIterator]() {
        return {
            splitPromise: this.split.bind(this),
            index: 0,
            async next() {
                let e = await this.splitPromise();
                return this.index !== e.length ? { done: !1, value: e[this.index++] } : { done: !0 };
            },
        };
    }
    split(e = !1) {
        return this.childElementCount > 0 && !e
            ? Promise.resolve(Array.from(this.children))
            : ((this.hasBeenSplitted = !0),
              new Promise((t) => {
                  requestAnimationFrame(() => {
                      this.innerHTML = this.originalContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
                      let i = {};
                      Array.from(this.children).forEach((e) => {
                          let t = parseInt(e.getBoundingClientRect().top);
                          i[t] = (i[t] || "") + e.textContent;
                      }),
                          (this.innerHTML = Object.values(i)
                              .map((t) => `<span ${this.hasAttribute("reveal") && !e ? "reveal" : ""} ${this.hasAttribute("reveal-visibility") && !e ? "reveal-visibility" : ""} style="display: block">${t.trim()}</span>`)
                              .join("")),
                          (this.style.opacity = this.hasAttribute("reveal") ? 1 : null),
                          (this.style.visibility = this.hasAttribute("reveal-visibility") ? "visible" : null),
                          t(Array.from(this.children));
                  });
              }));
    }
    async _onResize() {
        this.lastWidth !== window.innerWidth && this.hasBeenSplitted && (await this.split(!0), this.dispatchEvent(new CustomEvent("split-lines:re-split", { bubbles: !0 })), (this.lastWidth = window.innerWidth));
    }
};
window.customElements.define("split-lines", SplitLines);
var PopoverContent = class extends OpenableElement {
    connectedCallback() {
        super.connectedCallback(), this.delegate.on("click", ".popover__overlay", () => (this.open = !1));
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && document.documentElement.classList.toggle("lock-mobile", this.open);
    }
};
window.customElements.define("popover-content", PopoverContent);
var TabsNav = class extends HTMLElement {
    connectedCallback() {
        (this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"))),
            (this.scrollerElement = this.querySelector(".tabs-nav__scroller")),
            this.buttons.forEach((e) => e.addEventListener("click", () => this.selectButton(e))),
            this.addEventListener("shopify:block:select", (e) => this.selectButton(e.target, !e.detail.load)),
            (this.positionElement = document.createElement("span")),
            this.positionElement.classList.add("tabs-nav__position"),
            this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement),
            window.addEventListener("resize", this._onWindowResized.bind(this)),
            this._adjustNavigationPosition(),
            this.hasArrows && this._handleArrows();
    }
    get hasArrows() {
        return this.hasAttribute("arrows");
    }
    get selectedTabIndex() {
        return this.buttons.findIndex((e) => "true" === e.getAttribute("aria-expanded"));
    }
    get selectedButton() {
        return this.buttons.find((e) => "true" === e.getAttribute("aria-expanded"));
    }
    selectButton(e, t = !0) {
        if (!this.buttons.includes(e) || this.selectedButton === e) return;
        let i = document.getElementById(this.selectedButton.getAttribute("aria-controls")),
            n = document.getElementById(e.getAttribute("aria-controls"));
        t ? this._transitionContent(i, n) : ((i.hidden = !0), (n.hidden = !1)),
            this.selectedButton.setAttribute("aria-expanded", "false"),
            e.setAttribute("aria-expanded", "true"),
            triggerEvent(this, "tabs-nav:changed", { button: e }),
            this._adjustNavigationPosition();
    }
    addButton(e) {
        e.addEventListener("click", () => this.selectButton(e)), e.setAttribute("aria-expanded", "false"), this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", e), this.buttons.push(e), this._adjustNavigationPosition(!1);
    }
    _transitionContent(e, t) {
        e.animate({ opacity: [1, 0] }, { duration: 250, easing: "ease" }).onfinish = () => {
            (e.hidden = !0), (t.hidden = !1), t.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease" });
        };
    }
    _onWindowResized() {
        this._adjustNavigationPosition();
    }
    _adjustNavigationPosition(e = !0) {
        let t = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth,
            i = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / t,
            n = this.scrollerElement.clientWidth / 2;
        this.scrollerElement.scrollTo({ behavior: e ? "smooth" : "auto", left: this.selectedButton.offsetLeft - n + this.selectedButton.clientWidth / 2 }),
            e || (this.positionElement.style.transition = "none"),
            this.positionElement.style.setProperty("--scale", t),
            this.positionElement.style.setProperty("--translate", 100 * i + "%"),
            this.positionElement.clientWidth,
            requestAnimationFrame(() => {
                this.positionElement.classList.add("is-initialized"), (this.positionElement.style.transition = null);
            });
    }
    _handleArrows() {
        let e = this.querySelector(".tabs-nav__arrows");
        e.firstElementChild.addEventListener("click", () => {
            this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
        }),
            e.lastElementChild.addEventListener("click", () => {
                this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
            });
    }
};
window.customElements.define("tabs-nav", TabsNav);
var LibraryLoader = class {
    static load(e) {
        let t,
            i = "requested",
            n = "loaded",
            s = this.libraries[e];
        if (s)
            return s.status === i
                ? s.promise
                : s.status === n
                ? Promise.resolve()
                : ((t = new Promise(
                      "script" === s.type
                          ? (e, t) => {
                                let i = document.createElement("script");
                                (i.id = s.tagId),
                                    (i.src = s.src),
                                    (i.onerror = t),
                                    (i.onload = () => {
                                        (s.status = n), e();
                                    }),
                                    document.body.appendChild(i);
                            }
                          : (e, t) => {
                                let i = document.createElement("link");
                                (i.id = s.tagId),
                                    (i.href = s.src),
                                    (i.rel = "stylesheet"),
                                    (i.type = "text/css"),
                                    (i.onerror = t),
                                    (i.onload = () => {
                                        (s.status = n), e();
                                    }),
                                    document.body.appendChild(i);
                            }
                  )),
                  (s.promise = t),
                  (s.status = i),
                  t);
    }
};
__publicField(LibraryLoader, "libraries", {
    flickity: { tagId: "flickity", src: window.themeVariables.libs.flickity, type: "script" },
    photoswipe: { tagId: "photoswipe", src: window.themeVariables.libs.photoswipe, type: "script" },
    qrCode: { tagId: "qrCode", src: window.themeVariables.libs.qrCode, type: "script" },
    modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: "link" },
});
var QrCode = class extends HTMLElement {
    async connectedCallback() {
        await LibraryLoader.load("qrCode"), new window.QRCode(this, { text: this.getAttribute("identifier"), width: 200, height: 200 });
    }
};
window.customElements.define("qr-code", QrCode);
var CountrySelector = class extends HTMLSelectElement {
    connectedCallback() {
        if (((this.provinceElement = document.getElementById(this.getAttribute("aria-owns"))), this.addEventListener("change", this._updateProvinceVisibility.bind(this)), this.hasAttribute("data-default")))
            for (let e = 0; e !== this.options.length; ++e)
                if (this.options[e].text === this.getAttribute("data-default")) {
                    this.selectedIndex = e;
                    break;
                }
        this._updateProvinceVisibility();
        let e = "SELECT" === this.provinceElement.tagName ? this.provinceElement : this.provinceElement.querySelector("select");
        if (e.hasAttribute("data-default"))
            for (let t = 0; t !== e.options.length; ++t)
                if (e.options[t].text === e.getAttribute("data-default")) {
                    e.selectedIndex = t;
                    break;
                }
    }
    _updateProvinceVisibility() {
        let e = this.options[this.selectedIndex];
        if (!e) return;
        let t = JSON.parse(e.getAttribute("data-provinces") || "[]"),
            i = "SELECT" === this.provinceElement.tagName ? this.provinceElement : this.provinceElement.querySelector("select");
        (i.innerHTML = ""),
            0 !== t.length
                ? (t.forEach((e) => {
                      i.options.add(new Option(e[1], e[0]));
                  }),
                  (this.provinceElement.hidden = !1))
                : (this.provinceElement.hidden = !0);
    }
};
window.customElements.define("country-selector", CountrySelector, { extends: "select" });
var ModalContent = class extends OpenableElement {
    connectedCallback() {
        super.connectedCallback(), !this.appearAfterDelay || (this.onlyOnce && this.hasAppearedOnce) || setTimeout(() => (this.open = !0), this.apparitionDelay), this.delegate.on("click", ".modal__overlay", () => (this.open = !1));
    }
    get appearAfterDelay() {
        return this.hasAttribute("apparition-delay");
    }
    get apparitionDelay() {
        return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0);
    }
    get onlyOnce() {
        return this.hasAttribute("only-once");
    }
    get hasAppearedOnce() {
        return null !== localStorage.getItem("theme:popup-appeared");
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && (document.documentElement.classList.toggle("lock-all", this.open), this.open && localStorage.setItem("theme:popup-appeared", !0));
    }
};
window.customElements.define("modal-content", ModalContent);
var PriceRange = class extends HTMLElement {
    connectedCallback() {
        (this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child")),
            (this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child")),
            (this.textInputLowerBound = this.querySelector(".price-range__input:first-child input")),
            (this.textInputHigherBound = this.querySelector(".price-range__input:last-child input")),
            this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select()),
            this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select()),
            this.textInputLowerBound.addEventListener("change", (e) => {
                (e.target.value = Math.max(Math.min(parseInt(e.target.value), parseInt(this.textInputHigherBound.value || e.target.max) - 1), e.target.min)),
                    (this.rangeLowerBound.value = e.target.value),
                    this.rangeLowerBound.parentElement.style.setProperty("--range-min", (parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100 + "%");
            }),
            this.textInputHigherBound.addEventListener("change", (e) => {
                (e.target.value = Math.min(Math.max(parseInt(e.target.value), parseInt(this.textInputLowerBound.value || e.target.min) + 1), e.target.max)),
                    (this.rangeHigherBound.value = e.target.value),
                    this.rangeHigherBound.parentElement.style.setProperty("--range-max", (parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100 + "%");
            }),
            this.rangeLowerBound.addEventListener("change", (e) => {
                (this.textInputLowerBound.value = e.target.value), this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: !0 }));
            }),
            this.rangeHigherBound.addEventListener("change", (e) => {
                (this.textInputHigherBound.value = e.target.value), this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: !0 }));
            }),
            this.rangeLowerBound.addEventListener("input", (e) => {
                triggerEvent(this, "facet:abort-loading"),
                    (e.target.value = Math.min(parseInt(e.target.value), parseInt(this.textInputHigherBound.value || e.target.max) - 1)),
                    e.target.parentElement.style.setProperty("--range-min", (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + "%"),
                    (this.textInputLowerBound.value = e.target.value);
            }),
            this.rangeHigherBound.addEventListener("input", (e) => {
                triggerEvent(this, "facet:abort-loading"),
                    (e.target.value = Math.max(parseInt(e.target.value), parseInt(this.textInputLowerBound.value || e.target.min) + 1)),
                    e.target.parentElement.style.setProperty("--range-max", (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + "%"),
                    (this.textInputHigherBound.value = e.target.value);
            });
    }
};
window.customElements.define("price-range", PriceRange);
var LinkBar = class extends HTMLElement {
    connectedCallback() {
        let e = this.querySelector(".link-bar__link-item--selected");
        e &&
            requestAnimationFrame(() => {
                e.style.scrollSnapAlign = "none";
            });
    }
};
window.customElements.define("link-bar", LinkBar);
var MediaFeatures = class {
        static prefersReducedMotion() {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        static supportsHover() {
            return window.matchMedia("(pointer: fine)").matches;
        }
    },
    FlickityCarousel = class extends CustomHTMLElement {
        constructor() {
            super(), 1 !== this.childElementCount && (this.addEventListener("flickity:ready", this._preloadNextImage.bind(this)), this.addEventListener("flickity:slide-changed", this._preloadNextImage.bind(this)), this._createFlickity());
        }
        async disconnectedCallback() {
            this.flickity && (await this.flickity).destroy();
        }
        get flickityConfig() {
            return JSON.parse(this.getAttribute("flickity-config"));
        }
        get flickityInstance() {
            return this.flickity;
        }
        async next() {
            (await this.flickityInstance).next();
        }
        async previous() {
            (await this.flickityInstance).previous();
        }
        async select(e) {
            (await this.flickityInstance).selectCell(e);
        }
        async setDraggable(e) {
            let t = await this.flickity;
            (t.options.draggable = e), t.updateDraggable();
        }
        async reload() {
            (await this.flickity).destroy(),
                this.flickityConfig.cellSelector &&
                    Array.from(this.children)
                        .sort((e, t) => (parseInt(e.getAttribute("data-original-position")) > parseInt(t.getAttribute("data-original-position")) ? 1 : -1))
                        .forEach((e) => this.appendChild(e)),
                this._createFlickity();
        }
        async _createFlickity() {
            (this.flickity = new Promise(async (e) => {
                await LibraryLoader.load("flickity"),
                    await this.untilVisible({ rootMargin: "400px", threshold: 0 }),
                    e(
                        new window.ThemeFlickity(this, {
                            ...this.flickityConfig,
                            rightToLeft: "rtl" === window.themeVariables.settings.direction,
                            accessibility: MediaFeatures.supportsHover(),
                            on: { ready: (e) => triggerEvent(this, "flickity:ready", e), change: (e) => triggerEvent(this, "flickity:slide-changed", e), settle: (e) => triggerEvent(this, "flickity:slide-settled", e) },
                        })
                    );
            })),
                this.hasAttribute("click-nav") && ((await this.flickityInstance).on("staticClick", this._onStaticClick.bind(this)), this.addEventListener("mousemove", this._onMouseMove.bind(this)));
        }
        async _onStaticClick(e, t, i) {
            let n = await this.flickityInstance,
                s = n.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(n.selectedElement.getAttribute("data-media-type"));
            if (!i || s || window.matchMedia(window.themeVariables.breakpoints.phone).matches) return;
            let a = n.viewport.getBoundingClientRect(),
                r = Math.floor(a.right - a.width / 2);
            t.clientX > r ? n.next() : n.previous();
        }
        async _onMouseMove(e) {
            let t = await this.flickityInstance,
                i = t.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(t.selectedElement.getAttribute("data-media-type"));
            this.classList.toggle("is-hovering-right", e.offsetX > this.clientWidth / 2 && !i), this.classList.toggle("is-hovering-left", e.offsetX <= this.clientWidth / 2 && !i);
        }
        async _preloadNextImage() {
            let e = await this.flickity;
            e.selectedElement.nextElementSibling && e.selectedElement.nextElementSibling.querySelector("img")?.setAttribute("loading", "eager");
        }
    };
function deepQuerySelector(e, t) {
    let i = e.querySelector(t);
    if (i) return i;
    for (let n of e.querySelectorAll("template")) if ((i = deepQuerySelector(n.content, t))) return i;
    return null;
}
function getSiblings(e, t, i = !1) {
    let n = [],
        s = e;
    for (; (s = s.previousElementSibling); ) (t && !s.matches(t)) || n.push(s);
    for (i && n.push(e), s = e; (s = s.nextElementSibling); ) (t && !s.matches(t)) || n.push(s);
    return n;
}
async function resolveAsyncIterator(e) {
    let t = [];
    for (let i of ((null != e && "function" == typeof e[Symbol.iterator]) || (e = [e]), e))
        if ("function" == typeof i[Symbol.asyncIterator]) for await (let e of i) t.push(e);
        else t.push(i);
    return t;
}
window.customElements.define("flickity-carousel", FlickityCarousel);
var FlickityControls = class extends CustomHTMLElement {
    async connectedCallback() {
        this.flickityCarousel.addEventListener("flickity:ready", this._onSlideChanged.bind(this, !1)),
            this.flickityCarousel.addEventListener("flickity:slide-changed", this._onSlideChanged.bind(this, !0)),
            this.delegate.on("click", '[data-action="prev"]', () => this.flickityCarousel.previous()),
            this.delegate.on("click", '[data-action="next"]', () => this.flickityCarousel.next()),
            this.delegate.on("click", '[data-action="select"]', (e, t) => this.flickityCarousel.select(`#${t.getAttribute("aria-controls")}`));
    }
    get flickityCarousel() {
        return (this._flickityCarousel = this._flickityCarousel || document.getElementById(this.getAttribute("controls")));
    }
    async _onSlideChanged(e = !0) {
        let t = await this.flickityCarousel.flickityInstance;
        Array.from(this.querySelectorAll(`[aria-controls="${t.selectedElement.id}"]`)).forEach((t) => {
            t.setAttribute("aria-current", "true"),
                getSiblings(t).forEach((e) => e.removeAttribute("aria-current")),
                requestAnimationFrame(() => {
                    if (t.offsetParent && t.offsetParent !== this) {
                        let i = t.offsetParent.clientHeight / 2,
                            n = t.offsetParent.clientWidth / 2;
                        t.offsetParent.scrollTo({ behavior: e ? "smooth" : "auto", top: t.offsetTop - i + t.clientHeight / 2, left: t.offsetLeft - n + t.clientWidth / 2 });
                    }
                });
        });
    }
};
window.customElements.define("flickity-controls", FlickityControls);
var ExternalVideo = class extends CustomHTMLElement {
    constructor() {
        super(),
            (this.hasLoaded = !1),
            (async () => {
                this.autoPlay ? (await this.untilVisible({ rootMargin: "300px", threshold: 0 }), this.play()) : this.addEventListener("click", this.play.bind(this), { once: !0 });
            })();
    }
    get autoPlay() {
        return this.hasAttribute("autoplay");
    }
    get provider() {
        return this.getAttribute("provider");
    }
    async play() {
        this.hasLoaded || (await this._setupPlayer()),
            "youtube" === this.provider
                ? setTimeout(() => {
                      this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
                  }, 150)
                : "vimeo" === this.provider && this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
    }
    pause() {
        this.hasLoaded &&
            ("youtube" === this.provider
                ? this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: "" }), "*")
                : "vimeo" === this.provider && this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*"));
    }
    _setupPlayer() {
        return this._setupPromise
            ? this._setupPromise
            : (this._setupPromise = new Promise((e) => {
                  let t = this.querySelector("template"),
                      i = t.content.firstElementChild.cloneNode(!0);
                  (i.onload = () => {
                      (this.hasLoaded = !0), e();
                  }),
                      this.autoPlay ? t.replaceWith(i) : ((this.innerHTML = ""), this.appendChild(i));
              }));
    }
};
window.customElements.define("external-video", ExternalVideo);
var ProductLoader = class {
    static load(e) {
        if (e)
            return (
                this.loadedProducts[e] ||
                    (this.loadedProducts[e] = new Promise(async (t) => {
                        let i = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${e}.js`);
                        t(await i.json());
                    })),
                this.loadedProducts[e]
            );
    }
};
__publicField(ProductLoader, "loadedProducts", {});
var ModelMedia = class extends HTMLElement {
    constructor() {
        super(),
            LibraryLoader.load("modelViewerUiStyles"),
            window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: this._setupShopifyXr.bind(this) },
                {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: () => {
                        this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild, { focusOnPlay: !1 });
                        let e = this.querySelector("model-viewer");
                        e.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
                            e.dispatchEvent(new CustomEvent("model:played", { bubbles: !0 }));
                        }),
                            e.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
                                e.dispatchEvent(new CustomEvent("model:paused", { bubbles: !0 }));
                            });
                    },
                },
            ]);
    }
    disconnectedCallback() {
        this.modelUi?.destroy();
    }
    play() {
        this.modelUi && this.modelUi.play();
    }
    pause() {
        this.modelUi && this.modelUi.pause();
    }
    async _setupShopifyXr() {
        if (window.ShopifyXR) {
            let e = (await ProductLoader.load(this.getAttribute("product-handle"))).media.filter((e) => "model" === e.media_type);
            window.ShopifyXR.addModels(e), window.ShopifyXR.setupXRElements();
        } else document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    }
};
window.customElements.define("model-media", ModelMedia);
var NativeVideo = class extends HTMLElement {
    constructor() {
        super(), (this.hasLoaded = !1), this.autoPlay ? this.play() : this.addEventListener("click", this.play.bind(this), { once: !0 });
    }
    get autoPlay() {
        return this.hasAttribute("autoplay");
    }
    play() {
        this.hasLoaded || this._replaceContent(), this.querySelector("video").play();
    }
    pause() {
        this.hasLoaded && this.querySelector("video").pause();
    }
    _replaceContent() {
        let e = this.querySelector("template");
        e &&
            ((e = e.content.firstElementChild.cloneNode(!0)),
            this.hasAttribute("autoplay") || (this.innerHTML = ""),
            this.appendChild(e),
            this.firstElementChild.addEventListener("play", () => {
                this.dispatchEvent(new CustomEvent("video:played", { bubbles: !0 }));
            }),
            this.firstElementChild.addEventListener("pause", () => {
                this.dispatchEvent(new CustomEvent("video:paused", { bubbles: !0 }));
            }),
            (this.hasLoaded = !0));
    }
};
window.customElements.define("native-video", NativeVideo);
var ComboBox = class extends OpenableElement {
    connectedCallback() {
        if (
            (super.connectedCallback(),
            (this.options = Array.from(this.querySelectorAll('[role="option"]'))),
            this.delegate.on("click", '[role="option"]', this._onValueClicked.bind(this)),
            this.delegate.on("keydown", '[role="listbox"]', this._onKeyDown.bind(this)),
            this.delegate.on("change", "select", this._onValueChanged.bind(this)),
            this.delegate.on("click", ".combo-box__overlay", () => (this.open = !1)),
            this.hasAttribute("fit-toggle"))
        ) {
            let e = Math.max(...this.options.map((e) => e.clientWidth)),
                t = document.querySelector(`[aria-controls="${this.id}"]`);
            t && t.style.setProperty("--largest-option-width", `${e + 2}px`);
        }
    }
    get nativeControl() {
        return this.querySelector('input[type="hidden"]') || this.querySelector("select");
    }
    set selectedValue(e) {
        this.options.forEach((t) => {
            t.setAttribute("aria-selected", t.getAttribute("value") === e ? "true" : "false");
        });
    }
    attributeChangedCallback(e, t, i) {
        if ((super.attributeChangedCallback(e, t, i), "open" === e)) {
            if (this.open) {
                let e = this.getBoundingClientRect();
                this.classList.toggle("combo-box--top", e.top >= (window.innerHeight / 2) * 1.5), setTimeout(() => this.focusTrap.activate(), 150);
            } else this.focusTrap.deactivate(), setTimeout(() => this.classList.remove("combo-box--top"), 200);
            document.documentElement.classList.toggle("lock-mobile", this.open);
        }
    }
    _onValueClicked(e, t) {
        (this.selectedValue = t.value), this.nativeControl.value !== t.value && ((this.nativeControl.value = t.value), this.nativeControl.dispatchEvent(new Event("change", { bubbles: !0 }))), (this.open = !1);
    }
    _onValueChanged(e, t) {
        "SELECT" === this.nativeControl.tagName && Array.from(this.nativeControl.options).forEach((e) => e.toggleAttribute("selected", t.value === e.value)), (this.selectedValue = t.value);
    }
    _onKeyDown(e) {
        ("ArrowDown" !== e.key && "ArrowUp" !== e.key) || (e.preventDefault(), "ArrowDown" === e.key ? document.activeElement.nextElementSibling?.focus() : document.activeElement.previousElementSibling?.focus());
    }
};
window.customElements.define("combo-box", ComboBox);
var QuantitySelector = class extends CustomHTMLElement {
    connectedCallback() {
        (this.inputElement = this.querySelector("input")),
            this.delegate.on("click", "button:first-child", () => (this.inputElement.quantity = this.inputElement.quantity - 1)),
            this.delegate.on("click", "button:last-child", () => (this.inputElement.quantity = this.inputElement.quantity + 1));
    }
};
window.customElements.define("quantity-selector", QuantitySelector);
var InputNumber = class extends HTMLInputElement {
    connectedCallback() {
        this.addEventListener("input", this._onValueInput.bind(this)), this.addEventListener("change", this._onValueChanged.bind(this)), this.addEventListener("keydown", this._onKeyDown.bind(this));
    }
    get quantity() {
        return parseInt(this.value);
    }
    set quantity(e) {
        let t = ("number" == typeof e || ("string" == typeof e && "" !== e.trim())) && !isNaN(e);
        "" !== e && ((!t || e < 0) && (e = parseInt(e) || 1), (this.value = Math.max(this.min || 1, Math.min(e, this.max || Number.MAX_VALUE)).toString()), (this.size = Math.max(this.value.length + 1, 2)));
    }
    _onValueInput() {
        this.quantity = this.value;
    }
    _onValueChanged() {
        "" === this.value && (this.quantity = 1);
    }
    _onKeyDown(e) {
        e.stopPropagation(), "ArrowUp" === e.key ? (this.quantity = this.quantity + 1) : "ArrowDown" === e.key && (this.quantity = this.quantity - 1);
    }
};
window.customElements.define("input-number", InputNumber, { extends: "input" });
var AnnouncementBar = class extends CustomHTMLElement {
    async connectedCallback() {
        await customElements.whenDefined("announcement-bar-item"),
            (this.items = Array.from(this.querySelectorAll("announcement-bar-item"))),
            (this.hasPendingTransition = !1),
            this.delegate.on("click", '[data-action="prev"]', this.previous.bind(this)),
            this.delegate.on("click", '[data-action="next"]', this.next.bind(this)),
            this.autoPlay && (this.delegate.on("announcement-bar:content:open", this._pausePlayer.bind(this)), this.delegate.on("announcement-bar:content:close", this._startPlayer.bind(this))),
            window.ResizeObserver && ((this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this))), this.resizeObserver.observe(this)),
            this.autoPlay && this._startPlayer(),
            Shopify.designMode && this.delegate.on("shopify:block:select", (e) => this.select(e.target.index, !1));
    }
    get autoPlay() {
        return this.hasAttribute("auto-play");
    }
    get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
    }
    previous() {
        this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
    }
    next() {
        this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
    }
    async select(e, t = !0) {
        this.selectedIndex === e ||
            this.hasPendingTransition ||
            (this.autoPlay && this._pausePlayer(), (this.hasPendingTransition = !0), await this.items[this.selectedIndex].deselect(t), await this.items[e].select(t), (this.hasPendingTransition = !1), this.autoPlay && this._startPlayer());
    }
    _pausePlayer() {
        clearInterval(this._interval);
    }
    _startPlayer() {
        clearInterval(this._interval), (this._interval = setInterval(this.next.bind(this), 1e3 * parseInt(this.getAttribute("cycle-speed"))));
    }
    _updateCustomProperties(e) {
        e.forEach((e) => {
            if (e.target === this) {
                let t = e.borderBoxSize ? (e.borderBoxSize.length > 0 ? e.borderBoxSize[0].blockSize : e.borderBoxSize.blockSize) : e.target.clientHeight;
                document.documentElement.style.setProperty("--announcement-bar-height", `${t}px`);
            }
        });
    }
};
window.customElements.define("announcement-bar", AnnouncementBar);
var AnnouncementBarItem = class extends CustomHTMLElement {
    connectedCallback() {
        this.hasContent &&
            ((this.contentElement = this.querySelector(".announcement-bar__content")),
            this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this)),
            this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this)),
            Shopify.designMode && (this.addEventListener("shopify:block:select", this.openContent.bind(this)), this.addEventListener("shopify:block:deselect", this.closeContent.bind(this))));
    }
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get hasContent() {
        return this.hasAttribute("has-content");
    }
    get selected() {
        return !this.hasAttribute("hidden");
    }
    get focusTrap() {
        return (this._trapFocus =
            this._trapFocus ||
            createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
                fallbackFocus: this,
                clickOutsideDeactivates: (e) => "BUTTON" !== e.target.tagName,
                allowOutsideClick: (e) => "BUTTON" === e.target.tagName,
                onDeactivate: this.closeContent.bind(this),
                preventScroll: !0,
            }));
    }
    async select(e = !0) {
        this.removeAttribute("hidden"),
            await new Promise((t) => {
                this.animate({ transform: ["translateY(8px)", "translateY(0)"], opacity: [0, 1] }, { duration: e ? 150 : 0, easing: "ease-in-out" }).onfinish = t;
            });
    }
    async deselect(e = !0) {
        await this.closeContent(),
            await new Promise((t) => {
                this.animate({ transform: ["translateY(0)", "translateY(-8px)"], opacity: [1, 0] }, { duration: e ? 150 : 0, easing: "ease-in-out" }).onfinish = t;
            }),
            this.setAttribute("hidden", "");
    }
    async openContent() {
        this.hasContent &&
            (this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), { once: !0 }),
            this.contentElement.removeAttribute("hidden"),
            document.documentElement.classList.add("lock-all"),
            this.dispatchEvent(new CustomEvent("announcement-bar:content:open", { bubbles: !0 })));
    }
    async closeContent() {
        if (!this.hasContent || this.contentElement.hasAttribute("hidden")) return Promise.resolve();
        await new Promise((e) => {
            this.contentElement.addEventListener("transitionend", () => e(), { once: !0 }),
                this.contentElement.setAttribute("hidden", ""),
                this.focusTrap.deactivate(),
                document.documentElement.classList.remove("lock-all"),
                this.dispatchEvent(new CustomEvent("announcement-bar:content:close", { bubbles: !0 }));
        });
    }
};
window.customElements.define("announcement-bar-item", AnnouncementBarItem);
var SearchPage = class extends HTMLElement {
    connectedCallback() {
        (this.facetToolbar = document.getElementById("mobile-facet-toolbar")),
            (this.tabsNav = document.getElementById("search-tabs-nav")),
            this.tabsNav.addEventListener("tabs-nav:changed", this._onCategoryChanged.bind(this)),
            this._completeSearch();
    }
    get terms() {
        return this.getAttribute("terms");
    }
    get completeFor() {
        return this.getAttribute("complete-for").split(",");
    }
    async _completeSearch() {
        let e = [];
        this.completeFor.forEach((t) => {
            e.push(
                fetch(
                    `${window.themeVariables.routes.searchUrl}?section_id=${this.getAttribute("section-id")}&q=${this.terms}&type=${t}&options[prefix]=last&options[unavailable_products]=${
                        window.themeVariables.settings.searchUnavailableProducts
                    }`
                )
            );
        });
        let t = await Promise.all(e);
        await Promise.all(
            t.map(async (e) => {
                let t = document.createElement("div");
                t.innerHTML = await e.text();
                let i = t.querySelector(".main-search__category-result"),
                    n = t.querySelector("#search-tabs-nav .tabs-nav__item");
                i && (i.setAttribute("hidden", ""), this.insertAdjacentElement("beforeend", i), this.tabsNav.addButton(n));
            })
        );
    }
    _onCategoryChanged(e) {
        let t = e.detail.button;
        this.facetToolbar.classList.toggle("is-collapsed", "product" !== t.getAttribute("data-type"));
    }
};
window.customElements.define("search-page", SearchPage);
var CookieBar = class extends CustomHTMLElement {
    connectedCallback() {
        window.Shopify &&
            window.Shopify.designMode &&
            (this.rootDelegate.on("shopify:section:select", (e) => filterShopifyEvent(e, this, () => (this.open = !0))), this.rootDelegate.on("shopify:section:deselect", (e) => filterShopifyEvent(e, this, () => (this.open = !1)))),
            this.delegate.on("click", '[data-action~="accept-policy"]', this._acceptPolicy.bind(this)),
            this.delegate.on("click", '[data-action~="decline-policy"]', this._declinePolicy.bind(this)),
            window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1", onLoad: this._onCookieBarSetup.bind(this) }]);
    }
    set open(e) {
        this.toggleAttribute("hidden", !e);
    }
    _onCookieBarSetup() {
        window.Shopify.customerPrivacy.shouldShowGDPRBanner() && (this.open = !0);
    }
    _acceptPolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(!0, () => (this.open = !1));
    }
    _declinePolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(!1, () => (this.open = !1));
    }
};
window.customElements.define("cookie-bar", CookieBar);
var ProductRecommendations = class extends HTMLElement {
    async connectedCallback() {
        let e = await fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}&intent=${this.intent}`),
            t = document.createElement("div");
        t.innerHTML = await e.text();
        let i = t.querySelector("product-recommendations");
        i.hasChildNodes() ? (this.innerHTML = i.innerHTML) : "complementary" === this.intent && this.remove();
    }
    get productId() {
        return this.getAttribute("product-id");
    }
    get sectionId() {
        return this.getAttribute("section-id");
    }
    get recommendationsCount() {
        return parseInt(this.getAttribute("recommendations-count") || 4);
    }
    get intent() {
        return this.getAttribute("intent");
    }
};
window.customElements.define("product-recommendations", ProductRecommendations);
var RecentlyViewedProducts = class extends HTMLElement {
    async connectedCallback() {
        if ("" === this.searchQueryString) return;
        let e = await fetch(`${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`),
            t = document.createElement("div");
        t.innerHTML = await e.text();
        let i = t.querySelector("recently-viewed-products");
        i.hasChildNodes() && (this.innerHTML = i.innerHTML);
    }
    get searchQueryString() {
        let e = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
        return (
            this.hasAttribute("exclude-product-id") && e.includes(parseInt(this.getAttribute("exclude-product-id"))) && e.splice(e.indexOf(parseInt(this.getAttribute("exclude-product-id"))), 1),
            e
                .map((e) => "id:" + e)
                .slice(0, this.productsCount)
                .join(" OR ")
        );
    }
    get sectionId() {
        return this.getAttribute("section-id");
    }
    get productsCount() {
        return this.getAttribute("products-count") || 4;
    }
};
function getSizedMediaUrl(e, t) {
    let i = "string" == typeof e ? e : e.preview_image ? e.preview_image.src : e.url;
    if (null === t) return i;
    if ("master" === t) return i.replace(/http(s)?:/, "");
    let n = i.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (n) {
        let e = i.split(n[0]),
            s = n[0];
        return (e[0] + "_" + t + s).replace(/http(s)?:/, "");
    }
    return null;
}
function getSupportedSizes(e, t) {
    let i = [],
        n = e.preview_image.width;
    return (
        t.forEach((e) => {
            n >= e && i.push(e);
        }),
        i
    );
}
function imageLoaded(e) {
    return new Promise((t) => {
        !e || "IMG" !== e.tagName || e.complete ? t() : (e.onload = () => t());
    });
}
window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
var CustomAnimation = class {
        constructor(e) {
            (this._effect = e), (this._playState = "idle"), (this._finished = Promise.resolve());
        }
        get finished() {
            return this._finished;
        }
        get animationEffects() {
            return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
        }
        cancel() {
            this.animationEffects.forEach((e) => e.cancel());
        }
        finish() {
            this.animationEffects.forEach((e) => e.finish());
        }
        play() {
            (this._playState = "running"),
                this._effect.play(),
                (this._finished = this._effect.finished),
                this._finished.then(
                    () => {
                        this._playState = "finished";
                    },
                    (e) => {
                        this._playState = "idle";
                    }
                );
        }
    },
    CustomKeyframeEffect = class {
        constructor(e, t, i = {}) {
            e &&
                ("Animation" in window ? (this._animation = new Animation(new KeyframeEffect(e, t, i))) : ((i.fill = "forwards"), (this._animation = e.animate(t, i)), this._animation.pause()),
                this._animation.addEventListener("finish", () => {
                    (e.style.opacity = t.hasOwnProperty("opacity") ? t.opacity[t.opacity.length - 1] : null), (e.style.visibility = t.hasOwnProperty("visibility") ? t.visibility[t.visibility.length - 1] : null);
                }));
        }
        get finished() {
            return this._animation ? (this._animation.finished ? this._animation.finished : new Promise((e) => (this._animation.onfinish = e))) : Promise.resolve();
        }
        play() {
            this._animation && ((this._animation.startTime = null), this._animation.play());
        }
        cancel() {
            this._animation && this._animation.cancel();
        }
        finish() {
            this._animation && this._animation.finish();
        }
    },
    GroupEffect = class {
        constructor(e) {
            (this._childrenEffects = e), (this._finished = Promise.resolve());
        }
        get finished() {
            return this._finished;
        }
        get animationEffects() {
            return this._childrenEffects.flatMap((e) => (e instanceof CustomKeyframeEffect ? e : e.animationEffects));
        }
    },
    ParallelEffect = class extends GroupEffect {
        play() {
            let e = [];
            for (let t of this._childrenEffects) t.play(), e.push(t.finished);
            this._finished = Promise.all(e);
        }
    },
    SequenceEffect = class extends GroupEffect {
        play() {
            this._finished = new Promise(async (e, t) => {
                try {
                    for (let e of this._childrenEffects) e.play(), await e.finished;
                    e();
                } catch (e) {
                    t();
                }
            });
        }
    },
    SlideshowItem = class extends HTMLElement {
        async connectedCallback() {
            (this._pendingAnimations = []),
                this.addEventListener("split-lines:re-split", (e) => {
                    Array.from(e.target.children).forEach((e) => (e.style.visibility = this.selected ? "visible" : "hidden"));
                }),
                MediaFeatures.prefersReducedMotion() &&
                    (this.setAttribute("reveal-visibility", ""),
                    Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach((e) => {
                        e.removeAttribute("reveal"), e.removeAttribute("reveal-visibility");
                    }));
        }
        get index() {
            return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
            return !this.hasAttribute("hidden");
        }
        async transitionToLeave(e, t = !0) {
            "reveal" !== e && this.setAttribute("hidden", ""), this._pendingAnimations.forEach((e) => e.cancel()), (this._pendingAnimations = []);
            let i = null,
                n = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")),
                s = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (e) {
                case "sweep":
                    i = new CustomAnimation(
                        new SequenceEffect([
                            new CustomKeyframeEffect(this, { visibility: ["visible", "hidden"] }, { duration: 500 }),
                            new ParallelEffect(n.map((e) => new CustomKeyframeEffect(e, { opacity: [1, 0], visibility: ["visible", "hidden"] }))),
                        ])
                    );
                    break;
                case "fade":
                    i = new CustomAnimation(new CustomKeyframeEffect(this, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" }));
                    break;
                case "reveal":
                    i = new CustomAnimation(
                        new SequenceEffect([
                            new ParallelEffect(n.reverse().map((e) => new CustomKeyframeEffect(e, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" }))),
                            new ParallelEffect(
                                s.map((e) =>
                                    e.classList.contains("slideshow__image-wrapper--secondary")
                                        ? new CustomKeyframeEffect(e, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" })
                                        : new CustomKeyframeEffect(e, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" })
                                )
                            ),
                        ])
                    );
            }
            await this._executeAnimation(i, t), "reveal" === e && this.setAttribute("hidden", "");
        }
        async transitionToEnter(e, t = !0, i = !1) {
            this.removeAttribute("hidden"), await this._untilReady();
            let n = null,
                s = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")),
                a = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (e) {
                case "sweep":
                    n = new CustomAnimation(
                        new SequenceEffect([
                            new CustomKeyframeEffect(
                                this,
                                { visibility: ["hidden", "visible"], clipPath: i ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"] },
                                { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }
                            ),
                            new ParallelEffect(
                                s.map(
                                    (e, t) =>
                                        new CustomKeyframeEffect(
                                            e,
                                            { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] },
                                            { duration: 450, delay: 100 * t, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                                        )
                                )
                            ),
                        ])
                    );
                    break;
                case "fade":
                    n = new CustomAnimation(new CustomKeyframeEffect(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 250, easing: "ease-in-out" }));
                    break;
                case "reveal":
                    n = new CustomAnimation(
                        new SequenceEffect([
                            new ParallelEffect(
                                a.map((e) =>
                                    e.classList.contains("slideshow__image-wrapper--secondary")
                                        ? new CustomKeyframeEffect(e, { visibility: ["hidden", "visible"], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" })
                                        : new CustomKeyframeEffect(e, { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" })
                                )
                            ),
                            new ParallelEffect(
                                s.map(
                                    (e, t) =>
                                        new CustomKeyframeEffect(
                                            e,
                                            { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] },
                                            { duration: 450, delay: 100 * t, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                                        )
                                )
                            ),
                        ])
                    );
            }
            return this._executeAnimation(n, t);
        }
        async _executeAnimation(e, t) {
            return this._pendingAnimations.push(e), t ? e.play() : e.finish(), e.finished;
        }
        async _untilReady() {
            return Promise.all(this._getVisibleImages().map((e) => imageLoaded(e)));
        }
        _preloadImages() {
            this._getVisibleImages().forEach((e) => {
                e.setAttribute("loading", "eager");
            });
        }
        _getVisibleImages() {
            return Array.from(this.querySelectorAll("img")).filter((e) => "none" !== getComputedStyle(e.parentElement).display);
        }
    };
window.customElements.define("slide-show-item", SlideshowItem);
var VerticalScrollBlockerMixin = {
        _blockVerticalScroll(e = 18) {
            this.addEventListener("touchstart", (e) => {
                this.firstTouchClientX = e.touches[0].clientX;
            }),
                this.addEventListener(
                    "touchmove",
                    (t) => {
                        let i = t.touches[0].clientX - this.firstTouchClientX;
                        Math.abs(i) > e && t.preventDefault();
                    },
                    { passive: !1 }
                );
        },
    },
    Slideshow = class extends CustomHTMLElement {
        connectedCallback() {
            (this.items = Array.from(this.querySelectorAll("slide-show-item"))),
                (this.pageDots = this.querySelector("page-dots")),
                (this.isTransitioning = !1),
                this.items.length > 1 &&
                    (Shopify.designMode &&
                        (this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this)),
                        this.addEventListener("shopify:block:select", (e) => {
                            this.pausePlayer(), this.intersectionObserver.disconnect(), (!e.detail.load && e.target.selected) || this.select(e.target.index, !e.detail.load);
                        })),
                    this.addEventListener("swiperight", this.previous.bind(this)),
                    this.addEventListener("swipeleft", this.next.bind(this)),
                    this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index)),
                    this._blockVerticalScroll()),
                this._setupVisibility();
        }
        get selectedIndex() {
            return this.items.findIndex((e) => e.selected);
        }
        get transitionType() {
            return MediaFeatures.prefersReducedMotion() ? "fade" : this.getAttribute("transition-type");
        }
        async _setupVisibility() {
            this.hasAttribute("reveal-on-scroll") && (await this.untilVisible(), await this.items[this.selectedIndex].transitionToEnter(this.transitionType).catch((e) => {})), this.startPlayer();
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, !0, !0);
        }
        next() {
            this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, !0, !1);
        }
        async select(e, t = !0, i = !1) {
            if ("reveal" === this.transitionType && this.isTransitioning) return;
            this.isTransitioning = !0;
            let n = this.items[this.selectedIndex],
                s = this.items[e];
            this.items[(s.index + 1) % this.items.length]._preloadImages(),
                n && n !== s && ("reveal" !== this.transitionType ? n.transitionToLeave(this.transitionType, t) : await n.transitionToLeave(this.transitionType, t)),
                this.pageDots && (this.pageDots.selectedIndex = s.index),
                await s.transitionToEnter(this.transitionType, t, i).catch((e) => {}),
                (this.isTransitioning = !1);
        }
        pausePlayer() {
            this.style.setProperty("--section-animation-play-state", "paused");
        }
        startPlayer() {
            this.hasAttribute("auto-play") && this.style.setProperty("--section-animation-play-state", "running");
        }
    };
Object.assign(Slideshow.prototype, VerticalScrollBlockerMixin), window.customElements.define("slide-show", Slideshow);
var ImageWithTextItem = class extends HTMLElement {
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
        return !this.hasAttribute("hidden");
    }
    get hasAttachedImage() {
        return this.hasAttribute("attached-image");
    }
    async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = this.querySelector(".image-with-text__text-wrapper"),
            i = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__content split-lines")),
            n = new CustomAnimation(
                new SequenceEffect([
                    new ParallelEffect(
                        i.map(
                            (e, t) =>
                                new CustomKeyframeEffect(
                                    e,
                                    { opacity: [0, 0.2, 1], transform: ["translateY(100%)", "translateY(0)"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"] },
                                    { duration: 350, delay: 120 * t, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                                )
                        )
                    ),
                    new CustomKeyframeEffect(t, { opacity: [0, 1] }, { duration: 300 }),
                ])
            );
        return e ? n.play() : n.finish(), n.finished;
    }
    async transitionToLeave(e = !0) {
        let t = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines")),
            i = new CustomAnimation(new ParallelEffect(t.map((e) => new CustomKeyframeEffect(e, { opacity: [1, 0] }, { duration: 200 }))));
        e ? i.play() : i.finish(), await i.finished, this.setAttribute("hidden", "");
    }
};
window.customElements.define("image-with-text-item", ImageWithTextItem);
var ImageWithText = class extends CustomHTMLElement {
    connectedCallback() {
        (this.items = Array.from(this.querySelectorAll("image-with-text-item"))),
            (this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image"))),
            (this.pageDots = this.querySelector("page-dots")),
            (this.hasPendingTransition = !1),
            this.items.length > 1 &&
                (this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index)),
                Shopify.designMode &&
                    (this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this)),
                    this.addEventListener("shopify:block:select", (e) => {
                        this.intersectionObserver.disconnect(), this.pausePlayer(), this.select(e.target.index, !e.detail.load);
                    }))),
            this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible(), this.hasAttribute("reveal-on-scroll") && (await this.transitionImage(this.selectedIndex), this.select(this.selectedIndex)), this.startPlayer();
    }
    get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
    }
    async select(e, t = !0) {
        this.hasPendingTransition ||
            ((this.hasPendingTransition = !0),
            (!this.items[e].hasAttachedImage && t) || (await this.transitionImage(e, t)),
            this.selectedIndex !== e && (await this.items[this.selectedIndex].transitionToLeave(t)),
            this.pageDots && (this.pageDots.selectedIndex = e),
            await this.items[e].transitionToEnter(t),
            (this.hasPendingTransition = !1));
    }
    async transitionImage(e, t = !0) {
        let i = this.imageItems.find((e) => !e.hasAttribute("hidden")),
            n = this.imageItems.find((t) => t.id === this.items[e].getAttribute("attached-image")) || i;
        i.setAttribute("hidden", ""), n.removeAttribute("hidden"), await imageLoaded(n);
        let s = new CustomAnimation(new CustomKeyframeEffect(n, { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"] }, { duration: 600, easing: "cubic-bezier(1, 0, 0, 1)" }));
        t ? s.play() : s.finish();
    }
    pausePlayer() {
        this.style.setProperty("--section-animation-play-state", "paused");
    }
    startPlayer() {
        this.style.setProperty("--section-animation-play-state", "running");
    }
};
window.customElements.define("image-with-text", ImageWithText);
var TestimonialItem = class extends CustomHTMLElement {
    connectedCallback() {
        this.addEventListener("split-lines:re-split", (e) => {
            Array.from(e.target.children).forEach((e) => (e.style.visibility = this.selected ? "visible" : "hidden"));
        });
    }
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
        return !this.hasAttribute("hidden");
    }
    async transitionToLeave(e = !0) {
        let t = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")),
            i = new CustomAnimation(
                new ParallelEffect(
                    t
                        .reverse()
                        .map(
                            (e, t) =>
                                new CustomKeyframeEffect(
                                    e,
                                    { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"], transform: ["translateY(0)", "translateY(100%)"] },
                                    { duration: 350, delay: 60 * t, easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)" }
                                )
                        )
                )
            );
        e ? i.play() : i.finish(), await i.finished, this.setAttribute("hidden", "");
    }
    async transitionToEnter(e = !0) {
        let t = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")),
            i = new CustomAnimation(
                new ParallelEffect(
                    t.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"], transform: ["translateY(100%)", "translateY(0)"] },
                                { duration: 550, delay: 120 * t, easing: "cubic-bezier(0.23, 1, 0.32, 1)" }
                            )
                    )
                )
            );
        return this.removeAttribute("hidden"), e ? i.play() : i.finish(), i.finished;
    }
};
window.customElements.define("testimonial-item", TestimonialItem);
var TestimonialList = class extends CustomHTMLElement {
    connectedCallback() {
        (this.items = Array.from(this.querySelectorAll("testimonial-item"))),
            (this.pageDots = this.querySelector("page-dots")),
            (this.hasPendingTransition = !1),
            this.items.length > 1 &&
                (this.addEventListener("swiperight", this.previous.bind(this)),
                this.addEventListener("swipeleft", this.next.bind(this)),
                this.addEventListener("prev-next:prev", this.previous.bind(this)),
                this.addEventListener("prev-next:next", this.next.bind(this)),
                this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index)),
                Shopify.designMode &&
                    this.addEventListener("shopify:block:select", (e) => {
                        this.intersectionObserver?.disconnect(), (!e.detail.load && e.target.selected) || this.select(e.target.index, !e.detail.load);
                    }),
                this._blockVerticalScroll()),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
    }
    async _setupVisibility() {
        await this.untilVisible(), this.items[this.selectedIndex].transitionToEnter();
    }
    previous() {
        this.select((this.selectedIndex - 1 + this.items.length) % this.items.length);
    }
    next() {
        this.select((this.selectedIndex + 1 + this.items.length) % this.items.length);
    }
    async select(e, t = !0) {
        this.hasPendingTransition ||
            ((this.hasPendingTransition = !0), await this.items[this.selectedIndex].transitionToLeave(t), this.pageDots && (this.pageDots.selectedIndex = e), await this.items[e].transitionToEnter(t), (this.hasPendingTransition = !1));
    }
};
Object.assign(TestimonialList.prototype, VerticalScrollBlockerMixin), window.customElements.define("testimonial-list", TestimonialList);
var ShopTheLookItem = class extends HTMLElement {
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
        return !this.hasAttribute("hidden");
    }
    async transitionToLeave(e = !0) {
        this.setAttribute("hidden", "");
        let t = new CustomAnimation(new CustomKeyframeEffect(this, { visibility: ["visible", "hidden"] }, { duration: 500 }));
        return e ? t.play() : t.finish(), t.finished;
    }
    async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = Array.from(this.querySelectorAll(".shop-the-look__dot"));
        t.forEach((e) => (e.style.opacity = 0));
        let i = new CustomAnimation(
            new SequenceEffect([
                new ParallelEffect(Array.from(this.querySelectorAll(".shop-the-look__image")).map((e) => new CustomKeyframeEffect(e, { opacity: [1, 1] }, { duration: 0 }))),
                new CustomKeyframeEffect(this, { visibility: ["hidden", "visible"], zIndex: [0, 1], clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"] }, { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }),
                new ParallelEffect(t.map((e, t) => new CustomKeyframeEffect(e, { opacity: [0, 1], transform: ["scale(0)", "scale(1)"] }, { duration: 120, delay: 75 * t, easing: "ease-in-out" }))),
            ])
        );
        if ((e ? i.play() : i.finish(), await i.finished, window.matchMedia(window.themeVariables.breakpoints.tabletAndUp).matches)) {
            let e = this.querySelector(".shop-the-look__product-wrapper .shop-the-look__dot");
            e?.setAttribute("aria-expanded", "true");
        }
    }
};
window.customElements.define("shop-the-look-item", ShopTheLookItem);
var ShopTheLookNav = class extends CustomHTMLElement {
    connectedCallback() {
        (this.shopTheLook = this.closest("shop-the-look")),
            (this.inTransition = !1),
            (this.pendingTransition = !1),
            (this.pendingTransitionTo = null),
            this.delegate.on("click", '[data-action="prev"]', () => this.shopTheLook.previous()),
            this.delegate.on("click", '[data-action="next"]', () => this.shopTheLook.next());
    }
    transitionToIndex(e, t, i = !0) {
        let n = Array.from(this.querySelectorAll(".shop-the-look__counter-page-transition")),
            s = n[e],
            a = n[t];
        if (this.inTransition) return (this.pendingTransition = !0), void (this.pendingTransitionTo = t);
        (this.inTransition = !0),
            (s.animate({ transform: ["translateY(0)", "translateY(-100%)"] }, { duration: i ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" }).onfinish = () => {
                s.setAttribute("hidden", ""),
                    (this.inTransition = !1),
                    this.pendingTransition && this.pendingTransitionTo !== t && ((this.pendingTransition = !1), this.transitionToIndex(t, this.pendingTransitionTo, i), (this.pendingTransitionTo = null));
            }),
            a.removeAttribute("hidden"),
            a.animate({ transform: ["translateY(100%)", "translateY(0)"] }, { duration: i ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" });
    }
};
window.customElements.define("shop-the-look-nav", ShopTheLookNav);
var ShopTheLook = class extends CustomHTMLElement {
    connectedCallback() {
        (this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item"))),
            (this.nav = this.querySelector("shop-the-look-nav")),
            (this.hasPendingTransition = !1),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility(),
            this.lookItems.length > 1 &&
                Shopify.designMode &&
                this.addEventListener("shopify:block:select", async (e) => {
                    this.intersectionObserver.disconnect(),
                        await this.select(e.target.index, !e.detail.load),
                        this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0, fill: "forwards", easing: "ease-in-out" });
                });
    }
    get selectedIndex() {
        return this.lookItems.findIndex((e) => e.selected);
    }
    async _setupVisibility() {
        await this.untilVisible();
        let e = Array.from(this.lookItems[this.selectedIndex].querySelectorAll(".shop-the-look__image"));
        for (let t of e) null !== t.offsetParent && (await imageLoaded(t));
        await this.lookItems[this.selectedIndex].transitionToEnter(), this.nav && this.nav.animate({ opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 150, fill: "forwards", easing: "ease-in-out" });
    }
    previous() {
        this.select((this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length);
    }
    next() {
        this.select((this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length);
    }
    async select(e, t = !0) {
        let i = this.lookItems[this.selectedIndex],
            n = this.lookItems[e];
        this.hasPendingTransition || ((this.hasPendingTransition = !0), i !== n && (this.nav.transitionToIndex(this.selectedIndex, e, t), i.transitionToLeave()), n.transitionToEnter(t), (this.hasPendingTransition = !1));
    }
};
window.customElements.define("shop-the-look", ShopTheLook);
var CollectionList = class extends CustomHTMLElement {
    async connectedCallback() {
        (this.items = Array.from(this.querySelectorAll(".list-collections__item"))),
            this.hasAttribute("scrollable") &&
                ((this.scroller = this.querySelector(".list-collections__scroller")),
                this.addEventListener("prev-next:prev", this.previous.bind(this)),
                this.addEventListener("prev-next:next", this.next.bind(this)),
                this.addEventListener("shopify:block:select", (e) => e.target.scrollIntoView({ block: "nearest", inline: "center", behavior: e.detail.load ? "auto" : "smooth" }))),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible();
        let e = MediaFeatures.prefersReducedMotion(),
            t = new CustomAnimation(
                new ParallelEffect(
                    this.items.map(
                        (t, i) =>
                            new SequenceEffect([
                                new CustomKeyframeEffect(
                                    t.querySelector(".list-collections__item-image"),
                                    { opacity: [0, 1], transform: [`scale(${e ? 1 : 1.1})`, "scale(1)"] },
                                    { duration: 250, delay: e ? 0 : 150 * i, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
                                ),
                                new ParallelEffect(
                                    Array.from(t.querySelectorAll(".list-collections__item-info [reveal]")).map(
                                        (t, n) =>
                                            new CustomKeyframeEffect(
                                                t,
                                                { opacity: [0, 1], clipPath: [`inset(${e ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"], transform: [`translateY(${e ? 0 : "100%"})`, "translateY(0)"] },
                                                { duration: 200, delay: e ? 0 : 150 * i + 150 * n, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                                            )
                                    )
                                ),
                            ])
                    )
                )
            );
        this._hasSectionReloaded ? t.finish() : t.play();
    }
    previous() {
        let e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({ left: -this.items[0].clientWidth * e, behavior: "smooth" });
    }
    next() {
        let e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({ left: this.items[0].clientWidth * e, behavior: "smooth" });
    }
};
window.customElements.define("collection-list", CollectionList);
var ProductList = class extends CustomHTMLElement {
    constructor() {
        super(), (this.productListInner = this.querySelector(".product-list__inner")), (this.productItems = Array.from(this.querySelectorAll("product-item")));
    }
    connectedCallback() {
        this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this)), !this.hidden && this.staggerApparition && this._staggerProductsApparition();
    }
    get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
    }
    get apparitionAnimation() {
        return (this._animation =
            this._animation ||
            new CustomAnimation(
                new ParallelEffect(
                    this.productItems.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { opacity: [0, 1], transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"] },
                                { duration: 600, delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * t - Math.min(3 * t * t, 100 * t), easing: "ease" }
                            )
                    )
                )
            ));
    }
    previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
            i = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
        e.target.nextElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.productListInner.scrollLeft * t - (this.productListInner.clientWidth + i) <= 0),
            this.productListInner.scrollBy({ left: -(this.productListInner.clientWidth + i) * t, behavior: "smooth" });
    }
    next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
            i = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
        e.target.previousElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.productListInner.scrollLeft * t + 2 * (this.productListInner.clientWidth + i) >= this.productListInner.scrollWidth),
            this.productListInner.scrollBy({ left: (this.productListInner.clientWidth + i) * t, behavior: "smooth" });
    }
    attributeChangedCallback(e) {
        this.staggerApparition &&
            "hidden" === e &&
            (this.hidden
                ? this.apparitionAnimation.finish()
                : ((this.productListInner.scrollLeft = 0),
                  (this.productListInner.parentElement.scrollLeft = 0),
                  this.querySelector(".prev-next-button--prev")?.setAttribute("disabled", ""),
                  this.querySelector(".prev-next-button--next")?.removeAttribute("disabled"),
                  this._staggerProductsApparition()));
    }
    async _staggerProductsApparition() {
        this.productItems.forEach((e) => (e.style.opacity = 0)), await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 }), this.apparitionAnimation.play();
    }
};
__publicField(ProductList, "observedAttributes", ["hidden"]), window.customElements.define("product-list", ProductList);
var LogoList = class extends CustomHTMLElement {
    async connectedCallback() {
        (this.items = Array.from(this.querySelectorAll(".logo-list__item"))),
            (this.logoListScrollable = this.querySelector(".logo-list__list")),
            this.items.length > 1 && (this.addEventListener("prev-next:prev", this.previous.bind(this)), this.addEventListener("prev-next:next", this.next.bind(this))),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible({ rootMargin: "50px 0px", threshold: 0 });
        let e = new CustomAnimation(
            new ParallelEffect(
                this.items.map(
                    (e, t) =>
                        new CustomKeyframeEffect(
                            e,
                            { opacity: [0, 1], transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : "30px"})`, "translateY(0)"] },
                            { duration: 300, delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * t, easing: "ease" }
                        )
                )
            )
        );
        this._hasSectionReloaded ? e.finish() : e.play();
    }
    previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.nextElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * t - (this.logoListScrollable.clientWidth + 24) <= 0),
            this.logoListScrollable.scrollBy({ left: -(this.logoListScrollable.clientWidth + 24) * t, behavior: "smooth" });
    }
    next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.previousElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * t + 2 * (this.logoListScrollable.clientWidth + 24) >= this.logoListScrollable.scrollWidth),
            this.logoListScrollable.scrollBy({ left: (this.logoListScrollable.clientWidth + 24) * t, behavior: "smooth" });
    }
};
window.customElements.define("logo-list", LogoList);
var BlogPostNavigation = class extends HTMLElement {
    connectedCallback() {
        window.addEventListener("scroll", throttle(this._updateProgressBar.bind(this), 15));
    }
    get hasNextArticle() {
        return this.hasAttribute("has-next-article");
    }
    _updateProgressBar() {
        let e = getStickyHeaderOffset(),
            t = window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? 40 : 80,
            i = this.getBoundingClientRect(),
            n = this.parentElement.getBoundingClientRect(),
            s = n.bottom - (i.bottom - t),
            a = Math.max(-1 * (s / (n.height + t) - 1), 0);
        this.classList.toggle("is-visible", n.top < e && n.bottom > e + this.clientHeight - t),
            this.hasNextArticle && (a > 0.8 ? this.classList.add("article__nav--show-next") : this.classList.remove("article__nav--show-next")),
            this.style.setProperty("--transform", `${a}`);
    }
};
window.customElements.define("blog-post-navigation", BlogPostNavigation);
var MultiColumn = class extends CustomHTMLElement {
    connectedCallback() {
        this.hasAttribute("stack") ||
            ((this.multiColumnInner = this.querySelector(".multi-column__inner")),
            this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            Shopify.designMode &&
                this.addEventListener("shopify:block:select", (e) => {
                    e.target.scrollIntoView({ inline: "center", block: "nearest", behavior: e.detail.load ? "auto" : "smooth" });
                })),
            this.hasAttribute("stagger-apparition") && this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible({ threshold: Math.min(50 / this.clientHeight, 1) });
        let e = MediaFeatures.prefersReducedMotion(),
            t = new CustomAnimation(
                new ParallelEffect(
                    Array.from(this.querySelectorAll(".multi-column__item")).map(
                        (t, i) =>
                            new CustomKeyframeEffect(
                                t,
                                { opacity: [0, 1], transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"] },
                                { duration: 600, delay: e ? 0 : 100 * i, easing: "ease" }
                            )
                    )
                )
            );
        this._hasSectionReloaded ? t.finish() : t.play();
    }
    previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
            i = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
        e.target.nextElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * t - (this.multiColumnInner.clientWidth + i) <= 0),
            this.multiColumnInner.scrollBy({ left: -(this.multiColumnInner.clientWidth + i) * t, behavior: "smooth" });
    }
    next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
            i = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
        e.target.previousElementSibling.removeAttribute("disabled"),
            e.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * t + 2 * (this.multiColumnInner.clientWidth + i) >= this.multiColumnInner.scrollWidth),
            this.multiColumnInner.scrollBy({ left: (this.multiColumnInner.clientWidth + i) * t, behavior: "smooth" });
    }
};
window.customElements.define("multi-column", MultiColumn);
var GalleryList = class extends HTMLElement {
    connectedCallback() {
        (this.listItems = Array.from(this.querySelectorAll("gallery-item"))),
            (this.scrollBarElement = this.querySelector(".gallery__progress-bar")),
            (this.listWrapperElement = this.querySelector(".gallery__list-wrapper")),
            this.listItems.length > 1 &&
                (this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this)),
                this.addEventListener("prev-next:prev", this.previous.bind(this)),
                this.addEventListener("prev-next:next", this.next.bind(this)),
                Shopify.designMode && this.addEventListener("shopify:block:select", (e) => this.select(e.target.index, !e.detail.load)));
    }
    previous() {
        this.select([...this.listItems].reverse().find((e) => e.isOnLeftHalfPartOfScreen).index);
    }
    next() {
        this.select(this.listItems.findIndex((e) => e.isOnRightHalfPartOfScreen));
    }
    select(e, t = !0) {
        let i = this.listItems[e].getBoundingClientRect();
        this.listWrapperElement.scrollBy({ behavior: t ? "smooth" : "auto", left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2) });
    }
    _updateProgressBar(e) {
        this.scrollBarElement?.style.setProperty("--transform", `${e.detail.progress}%`);
    }
};
window.customElements.define("gallery-list", GalleryList);
var GalleryItem = class extends HTMLElement {
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get isOnRightHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction ? this.getBoundingClientRect().left > window.innerWidth / 2 : this.getBoundingClientRect().right < window.innerWidth / 2;
    }
    get isOnLeftHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction ? this.getBoundingClientRect().right < window.innerWidth / 2 : this.getBoundingClientRect().left > window.innerWidth / 2;
    }
};
window.customElements.define("gallery-item", GalleryItem);
var ImageWithTextOverlay = class extends CustomHTMLElement {
    connectedCallback() {
        this.hasAttribute("parallax") && !MediaFeatures.prefersReducedMotion() && ((this._hasPendingRaF = !1), (this._onScrollListener = this._onScroll.bind(this)), window.addEventListener("scroll", this._onScrollListener)),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._onScrollListener && window.removeEventListener("scroll", this._onScrollListener);
    }
    async _setupVisibility() {
        await this.untilVisible();
        let e = this.querySelector(".image-overlay__image"),
            t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
            i = MediaFeatures.prefersReducedMotion();
        await imageLoaded(e);
        let n = [
                new CustomKeyframeEffect(e, { opacity: [0, 1], transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
                new ParallelEffect(
                    t.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { opacity: [0, 0.2, 1], transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"], clipPath: [`inset(${i ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"] },
                                { duration: 300, delay: i ? 0 : 120 * t, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                            )
                    )
                ),
                new CustomKeyframeEffect(this.querySelector(".image-overlay__text-container"), { opacity: [0, 1] }, { duration: 300 }),
            ],
            s = new CustomAnimation(i ? new ParallelEffect(n) : new SequenceEffect(n));
        this._hasSectionReloaded ? s.finish() : s.play();
    }
    _onScroll() {
        this._hasPendingRaF ||
            ((this._hasPendingRaF = !0),
            requestAnimationFrame(() => {
                let e = this.getBoundingClientRect(),
                    t = this.querySelector(".image-overlay__content-wrapper"),
                    i = this.querySelector(".image-overlay__image"),
                    n = e.bottom,
                    s = e.height,
                    a = getStickyHeaderOffset();
                t && (t.style.opacity = Math.max(1 - 3 * (1 - Math.min(n / s, 1)), 0).toString()), i && (i.style.transform = `translateY(${100 - 100 * Math.max(1 - (1 - Math.min(n / (s + a), 1)), 0)}px)`), (this._hasPendingRaF = !1);
            }));
    }
};
window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
var ImageWithTextBlock = class extends CustomHTMLElement {
    async connectedCallback() {
        this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible();
        let e = Array.from(this.querySelectorAll(".image-with-text-block__image[reveal]")),
            t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
            i = MediaFeatures.prefersReducedMotion();
        for (let t of e) null !== t.offsetParent && (await imageLoaded(t));
        let n = [
                new ParallelEffect(e.map((e) => new CustomKeyframeEffect(e, { opacity: [0, 1], transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }))),
                new CustomKeyframeEffect(this.querySelector(".image-with-text-block__content"), { opacity: [0, 1], transform: [`translateY(${i ? 0 : "60px"})`, "translateY(0)"] }, { duration: 150, easing: "ease-in-out" }),
                new ParallelEffect(
                    t.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { opacity: [0, 0.2, 1], transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"], clipPath: [`inset(${i ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"] },
                                { duration: 300, delay: i ? 0 : 120 * t, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" }
                            )
                    )
                ),
                new CustomKeyframeEffect(this.querySelector(".image-with-text-block__text-container"), { opacity: [0, 1] }, { duration: 300 }),
            ],
            s = new CustomAnimation(i ? new ParallelEffect(n) : new SequenceEffect(n));
        this._hasSectionReloaded ? s.finish() : s.play();
    }
};
window.customElements.define("image-with-text-block", ImageWithTextBlock);
var ArticleList = class extends CustomHTMLElement {
    async connectedCallback() {
        if (((this.articleItems = Array.from(this.querySelectorAll(".article-item"))), this.staggerApparition)) {
            await this.untilVisible({ threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0 });
            let e = new CustomAnimation(
                new ParallelEffect(
                    this.articleItems.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { opacity: [0, 1], transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"] },
                                { duration: 600, delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * t - Math.min(3 * t * t, 100 * t), easing: "ease" }
                            )
                    )
                )
            );
            this._hasSectionReloaded ? e.finish() : e.play();
        }
    }
    get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
    }
};
window.customElements.define("article-list", ArticleList);
var BlogPostHeader = class extends HTMLElement {
    async connectedCallback() {
        let e = this.querySelector(".article__image");
        MediaFeatures.prefersReducedMotion()
            ? e.removeAttribute("reveal")
            : (await imageLoaded(e), e.animate({ opacity: [0, 1], transform: ["scale(1.1)", "scale(1)"] }, { duration: 500, fill: "forwards", easing: "cubic-bezier(0.65, 0, 0.35, 1)" }));
    }
};
window.customElements.define("blog-post-header", BlogPostHeader);
var PredictiveSearchInput = class extends HTMLInputElement {
    connectedCallback() {
        this.addEventListener("click", () => (document.getElementById(this.getAttribute("aria-controls")).open = !0));
    }
};
window.customElements.define("predictive-search-input", PredictiveSearchInput, { extends: "input" });
var DrawerContent = class extends OpenableElement {
    connectedCallback() {
        if ((super.connectedCallback(), this.hasAttribute("reverse-breakpoint"))) {
            this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right";
            let e = window.matchMedia(this.getAttribute("reverse-breakpoint"));
            e.addListener(this._checkReverseOpeningDirection.bind(this)), this._checkReverseOpeningDirection(e);
        }
        this.delegate.on("click", ".drawer__overlay", () => (this.open = !1));
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i), "open" === e && document.documentElement.classList.toggle("lock-all", this.open);
    }
    _checkReverseOpeningDirection(e) {
        this.classList.remove("drawer--from-left"), (("left" === this.originalDirection && !e.matches) || ("left" !== this.originalDirection && e.matches)) && this.classList.add("drawer--from-left");
    }
};
window.customElements.define("drawer-content", DrawerContent);
var PredictiveSearchDrawer = class extends DrawerContent {
    connectedCallback() {
        super.connectedCallback(),
            (this.inputElement = this.querySelector('[name="q"]')),
            (this.drawerContentElement = this.querySelector(".drawer__content")),
            (this.drawerFooterElement = this.querySelector(".drawer__footer")),
            (this.loadingStateElement = this.querySelector(".predictive-search__loading-state")),
            (this.resultsElement = this.querySelector(".predictive-search__results")),
            (this.menuListElement = this.querySelector(".predictive-search__menu-list")),
            this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200)),
            this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this));
    }
    async _onSearch(e, t) {
        if ("Enter" !== e.key)
            if ((this.abortController && this.abortController.abort(), this.drawerContentElement.classList.remove("drawer__content--center"), (this.drawerFooterElement.hidden = !0), "" === t.value))
                (this.loadingStateElement.hidden = !0), (this.resultsElement.hidden = !0), this.menuListElement && (this.menuListElement.hidden = !1);
            else {
                this.drawerContentElement.classList.add("drawer__content--center"), (this.loadingStateElement.hidden = !1), (this.resultsElement.hidden = !0), this.menuListElement && (this.menuListElement.hidden = !0);
                let e = {};
                try {
                    (this.abortController = new AbortController()), (e = this._supportPredictiveApi() ? await this._doPredictiveSearch(t.value) : await this._doLiquidSearch(t.value));
                } catch (e) {
                    if ("AbortError" === e.name) return;
                }
                (this.loadingStateElement.hidden = !0),
                    (this.resultsElement.hidden = !1),
                    this.menuListElement && (this.menuListElement.hidden = !0),
                    e.hasResults && ((this.drawerFooterElement.hidden = !1), this.drawerContentElement.classList.remove("drawer__content--center")),
                    (this.resultsElement.innerHTML = e.html);
            }
    }
    async _doPredictiveSearch(e) {
        let t = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${encodeURIComponent(e)}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`, { signal: this.abortController.signal }),
            i = document.createElement("div");
        return (i.innerHTML = await t.text()), { hasResults: null !== i.querySelector(".predictive-search__results-categories"), html: i.firstElementChild.innerHTML };
    }
    async _doLiquidSearch(e) {
        let t = await fetch(`${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(e)}&resources[limit]=50&section_id=predictive-search-compatibility`, { signal: this.abortController.signal }),
            i = document.createElement("div");
        return (i.innerHTML = await t.text()), { hasResults: null !== i.querySelector(".predictive-search__results-categories"), html: i.firstElementChild.innerHTML };
    }
    _startNewSearch() {
        (this.inputElement.value = ""), this.inputElement.focus();
        let e = new Event("input", { bubbles: !0, cancelable: !0 });
        this.inputElement.dispatchEvent(e);
    }
    _supportPredictiveApi() {
        return JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch;
    }
    _debounce(e, t) {
        let i = null;
        return (...n) => {
            clearTimeout(i),
                (i = setTimeout(() => {
                    e.apply(this, n);
                }, t));
        };
    }
};
window.customElements.define("predictive-search-drawer", PredictiveSearchDrawer);
var Timeline = class extends HTMLElement {
    connectedCallback() {
        if (
            ((this.prevNextButtons = this.querySelector("prev-next-buttons")),
            (this.pageDots = this.querySelector("page-dots")),
            (this.scrollBarElement = this.querySelector(".timeline__progress-bar")),
            (this.listWrapperElement = this.querySelector(".timeline__list-wrapper")),
            (this.listItemElements = Array.from(this.querySelectorAll(".timeline__item"))),
            (this.isScrolling = !1),
            this.listItemElements.length > 1)
        ) {
            this.addEventListener("prev-next:prev", this.previous.bind(this)),
                this.addEventListener("prev-next:next", this.next.bind(this)),
                this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index)),
                Shopify.designMode &&
                    this.addEventListener("shopify:block:select", (e) => {
                        this.select([...e.target.parentNode.children].indexOf(e.target), !e.detail.load);
                    }),
                (this.itemIntersectionObserver = new IntersectionObserver(this._onItemObserved.bind(this), { threshold: 0.4 }));
            let e = window.matchMedia(window.themeVariables.breakpoints.pocket);
            e.addListener(this._onMediaChanged.bind(this)), this._onMediaChanged(e);
        }
    }
    get selectedIndex() {
        return this.listItemElements.findIndex((e) => !e.hasAttribute("hidden"));
    }
    previous() {
        this.select(Math.max(0, this.selectedIndex - 1));
    }
    next() {
        this.select(Math.min(this.selectedIndex + 1, this.listItemElements.length - 1));
    }
    select(e, t = !0) {
        let i = this.listItemElements[e].getBoundingClientRect();
        t && ((this.isScrolling = !0), setTimeout(() => (this.isScrolling = !1), 800)),
            window.matchMedia(window.themeVariables.breakpoints.pocket).matches
                ? this.listWrapperElement.scrollTo({ behavior: t ? "smooth" : "auto", left: this.listItemElements[0].clientWidth * e })
                : this.listWrapperElement.scrollBy({ behavior: t ? "smooth" : "auto", left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2) }),
            this._onItemSelected(e);
    }
    _onItemSelected(e) {
        let t = this.listItemElements[e];
        t.removeAttribute("hidden", "false"),
            getSiblings(t).forEach((e) => e.setAttribute("hidden", "")),
            (this.prevNextButtons.isPrevDisabled = 0 === e),
            (this.prevNextButtons.isNextDisabled = e === this.listItemElements.length - 1),
            (this.pageDots.selectedIndex = e),
            this.scrollBarElement?.style.setProperty("--transform", (100 / (this.listItemElements.length - 1)) * e + "%");
    }
    _onItemObserved(e) {
        this.isScrolling ||
            e.forEach((e) => {
                e.isIntersecting && this._onItemSelected([...e.target.parentNode.children].indexOf(e.target));
            });
    }
    _onMediaChanged(e) {
        e.matches ? this.listItemElements.forEach((e) => this.itemIntersectionObserver.observe(e)) : this.listItemElements.forEach((e) => this.itemIntersectionObserver.unobserve(e));
    }
};
window.customElements.define("time-line", Timeline);
var PressList = class extends CustomHTMLElement {
    connectedCallback() {
        (this.pressItemsWrapper = this.querySelector(".press-list__wrapper")),
            (this.pressItems = Array.from(this.querySelectorAll("press-item"))),
            (this.pageDots = this.querySelector("page-dots")),
            this.pressItems.length > 1 &&
                (Shopify.designMode &&
                    this.addEventListener("shopify:block:select", (e) => {
                        this.intersectionObserver?.disconnect(), (!e.detail.load && e.target.selected) || this.select(e.target.index, !e.detail.load);
                    }),
                this.pressItemsWrapper.addEventListener("swiperight", this.previous.bind(this)),
                this.pressItemsWrapper.addEventListener("swipeleft", this.next.bind(this)),
                this.addEventListener("page-dots:changed", (e) => this.select(e.detail.index)),
                this._blockVerticalScroll()),
            this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
    }
    async _setupVisibility() {
        await this.untilVisible(), this.pressItems[this.selectedIndex].transitionToEnter();
    }
    get selectedIndex() {
        return this.pressItems.findIndex((e) => e.selected);
    }
    previous() {
        this.select((this.selectedIndex - 1 + this.pressItems.length) % this.pressItems.length);
    }
    next() {
        this.select((this.selectedIndex + 1 + this.pressItems.length) % this.pressItems.length);
    }
    async select(e, t = !0) {
        let i = this.pressItems[this.selectedIndex],
            n = this.pressItems[e];
        await i.transitionToLeave(t), (this.pageDots.selectedIndex = e), await n.transitionToEnter(t);
    }
};
Object.assign(PressList.prototype, VerticalScrollBlockerMixin), window.customElements.define("press-list", PressList);
var PressItem = class extends HTMLElement {
    connectedCallback() {
        this.addEventListener("split-lines:re-split", (e) => {
            Array.from(e.target.children).forEach((e) => (e.style.visibility = this.selected ? "visible" : "hidden"));
        });
    }
    get index() {
        return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
        return !this.hasAttribute("hidden");
    }
    async transitionToLeave(e = !0) {
        let t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
            i = new CustomAnimation(
                new ParallelEffect(
                    t
                        .reverse()
                        .map(
                            (e, t) =>
                                new CustomKeyframeEffect(
                                    e,
                                    { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"], transform: ["translateY(0)", "translateY(100%)"] },
                                    { duration: 350, delay: 60 * t, easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)" }
                                )
                        )
                )
            );
        e ? i.play() : i.finish(), await i.finished, this.setAttribute("hidden", "");
    }
    async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author")),
            i = new CustomAnimation(
                new ParallelEffect(
                    t.map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"], transform: ["translateY(100%)", "translateY(0)"] },
                                { duration: 550, delay: 120 * t, easing: "cubic-bezier(0.23, 1, 0.32, 1)" }
                            )
                    )
                )
            );
        return e ? i.play() : i.finish(), i.finished;
    }
};
window.customElements.define("press-item", PressItem);
var DesktopNavigation = class extends CustomHTMLElement {
    connectedCallback() {
        (this.openingTimeout = null),
            (this.currentMegaMenu = null),
            this.delegate.on(
                "mouseenter",
                ".has-dropdown",
                (e, t) => {
                    e.target === t && null !== e.relatedTarget && this.openDropdown(t);
                },
                !0
            ),
            this.delegate.on("click", ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]", (e, t) => {
                window.matchMedia("(hover: hover)").matches || "true" === t.getAttribute("aria-expanded") || (e.preventDefault(), this.openDropdown(t.parentElement));
            }),
            this.delegate.on("shopify:block:select", (e) => this.openDropdown(e.target.parentElement)),
            this.delegate.on("shopify:block:deselect", (e) => this.closeDropdown(e.target.parentElement));
    }
    openDropdown(e) {
        let t = e.querySelector("[aria-controls]"),
            i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
        this.currentMegaMenu = i.classList.contains("mega-menu") ? i : null;
        let n = setTimeout(() => {
            if ("true" === t.getAttribute("aria-expanded")) return;
            if ((t.setAttribute("aria-expanded", "true"), i.removeAttribute("hidden"), i.classList.contains("mega-menu") && !MediaFeatures.prefersReducedMotion())) {
                let e = Array.from(i.querySelectorAll(".mega-menu__column, .mega-menu__image-push"));
                e.forEach((e) => {
                    e.getAnimations().forEach((e) => e.cancel()), (e.style.opacity = 0);
                }),
                    new CustomAnimation(
                        new ParallelEffect(
                            e.map((e, t) => new CustomKeyframeEffect(e, { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 250, delay: 100 + 60 * t, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }))
                        )
                    ).play();
            }
            let s = (t) => {
                    null !== t.relatedTarget && (this.closeDropdown(e), e.removeEventListener("mouseleave", s));
                },
                a = () => {
                    this.closeDropdown(e), document.documentElement.removeEventListener("mouseleave", a);
                };
            e.addEventListener("mouseleave", s), document.documentElement.addEventListener("mouseleave", a), (n = null), this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open", { bubbles: !0 }));
        }, 100);
        e.addEventListener(
            "mouseleave",
            () => {
                n && clearTimeout(n);
            },
            { once: !0 }
        );
    }
    closeDropdown(e) {
        let t = e.querySelector("[aria-controls]"),
            i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
        requestAnimationFrame(() => {
            i.classList.add("is-closing"),
                t.setAttribute("aria-expanded", "false"),
                setTimeout(
                    () => {
                        i.setAttribute("hidden", ""), clearTimeout(this.openingTimeout), i.classList.remove("is-closing");
                    },
                    i.classList.contains("mega-menu") && this.currentMegaMenu !== i ? 250 : 0
                ),
                this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:close", { bubbles: !0 }));
        });
    }
};
window.customElements.define("desktop-navigation", DesktopNavigation);
var MobileNavigation = class extends DrawerContent {
    get apparitionAnimation() {
        if (this._apparitionAnimation) return this._apparitionAnimation;
        if (!MediaFeatures.prefersReducedMotion()) {
            let e = Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"]')),
                t = [];
            t.push(
                new ParallelEffect(
                    e.map(
                        (e, t) =>
                            new CustomKeyframeEffect(e, { opacity: [0, 1], transform: ["translateX(-40px)", "translateX(0)"] }, { duration: 300, delay: 300 + 120 * t - Math.min(2 * t * t, 120 * t), easing: "cubic-bezier(0.25, 1, 0.5, 1)" })
                    )
                )
            );
            let i = this.querySelector(".drawer__footer");
            return (
                i &&
                    t.push(
                        new CustomKeyframeEffect(
                            i,
                            { opacity: [0, 1], transform: ["translateY(100%)", "translateY(0)"] },
                            { duration: 300, delay: 500 + Math.max(125 * e.length - 25 * e.length, 25), easing: "cubic-bezier(0.25, 1, 0.5, 1)" }
                        )
                    ),
                (this._apparitionAnimation = new CustomAnimation(new ParallelEffect(t)))
            );
        }
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
            "open" === e &&
                (this.open && this.apparitionAnimation && (Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"], .drawer__footer')).forEach((e) => (e.style.opacity = 0)), this.apparitionAnimation.play()),
                triggerEvent(this, this.open ? "mobile-nav:open" : "mobile-nav:close"));
    }
};
window.customElements.define("mobile-navigation", MobileNavigation);
var StoreHeader = class extends CustomHTMLElement {
    connectedCallback() {
        window.ResizeObserver && ((this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this))), this.resizeObserver.observe(this), this.resizeObserver.observe(this.querySelector(".header__wrapper"))),
            this.isTransparent &&
                ((this.isTransparencyDetectionLocked = !1),
                this.delegate.on("desktop-nav:dropdown:open", () => (this.lockTransparency = !0)),
                this.delegate.on("desktop-nav:dropdown:close", () => (this.lockTransparency = !1)),
                this.rootDelegate.on("mobile-nav:open", () => (this.lockTransparency = !0)),
                this.rootDelegate.on("mobile-nav:close", () => (this.lockTransparency = !1)),
                this.delegate.on("mouseenter", this._checkTransparentHeader.bind(this), !0),
                this.delegate.on("mouseleave", this._checkTransparentHeader.bind(this)),
                this.isSticky && (this._checkTransparentHeader(), (this._onWindowScrollListener = throttle(this._checkTransparentHeader.bind(this), 100)), window.addEventListener("scroll", this._onWindowScrollListener)));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), window.ResizeObserver && this.resizeObserver.disconnect(), this.isTransparent && this.isSticky && window.removeEventListener("scroll", this._onWindowScrollListener);
    }
    get isSticky() {
        return this.hasAttribute("sticky");
    }
    get isTransparent() {
        return this.hasAttribute("transparent");
    }
    get transparentHeaderThreshold() {
        return 25;
    }
    set lockTransparency(e) {
        (this.isTransparencyDetectionLocked = e), this._checkTransparentHeader();
    }
    _updateCustomProperties(e) {
        e.forEach((e) => {
            if (e.target === this) {
                let t = e.borderBoxSize ? (e.borderBoxSize.length > 0 ? e.borderBoxSize[0].blockSize : e.borderBoxSize.blockSize) : e.target.clientHeight;
                document.documentElement.style.setProperty("--header-height", `${t}px`);
            }
            if (e.target.classList.contains("header__wrapper")) {
                let t = e.borderBoxSize ? (e.borderBoxSize.length > 0 ? e.borderBoxSize[0].blockSize : e.borderBoxSize.blockSize) : e.target.clientHeight;
                document.documentElement.style.setProperty("--header-height-without-bottom-nav", `${t}px`);
            }
        });
    }
    _checkTransparentHeader(e) {
        this.isTransparencyDetectionLocked || window.scrollY > this.transparentHeaderThreshold || (e && "mouseenter" === e.type) ? this.classList.remove("header--transparent") : this.classList.add("header--transparent");
    }
};
window.customElements.define("store-header", StoreHeader);
var _abortController,
    _ProductRerender_instances,
    onRerender_fn,
    GiftCardRecipient = class extends HTMLElement {
        connectedCallback() {
            let e = Array.from(this.querySelectorAll('[name*="properties"]')),
                t = "properties[__shopify_send_gift_card_to_recipient]";
            (this.recipientCheckbox = e.find((e) => e.name === t)),
                (this.recipientOtherProperties = e.filter((e) => e.name !== t)),
                (this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields")),
                this.recipientCheckbox?.addEventListener("change", this._synchronizeProperties.bind(this)),
                (this.offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]')),
                this.offsetProperty && (this.offsetProperty.value = new Date().getTimezoneOffset().toString()),
                (this.recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]'));
            let i = new Date(),
                n = new Date();
            n.setDate(i.getDate() + 90), this.recipientSendOnProperty?.setAttribute("min", this._formatDate(i)), this.recipientSendOnProperty?.setAttribute("max", this._formatDate(n)), this._synchronizeProperties();
        }
        _synchronizeProperties() {
            this.recipientOtherProperties.forEach((e) => (e.disabled = !this.recipientCheckbox.checked)), this.recipientFieldsContainer.classList.toggle("js:hidden", !this.recipientCheckbox.checked);
        }
        _formatDate(e) {
            let t = e.getTimezoneOffset();
            return new Date(e.getTime() - 60 * t * 1e3).toISOString().split("T")[0];
        }
    };
window.customElements.get("gift-card-recipient") || window.customElements.define("gift-card-recipient", GiftCardRecipient);
var ProductRerender = class extends HTMLElement {
    constructor() {
        super(...arguments), __privateAdd(this, _ProductRerender_instances), __privateAdd(this, _abortController);
    }
    connectedCallback() {
        __privateSet(this, _abortController, new AbortController()),
            (this.id && this.hasAttribute("observe-form")) || console.warn('The <product-rerender> requires an ID to identify the element to re-render, and an "observe-form" attribute referencing to the form to monitor.'),
            document.forms[this.getAttribute("observe-form")]?.addEventListener("product:rerender", __privateMethod(this, _ProductRerender_instances, onRerender_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
    }
    disconnectedCallback() {
        __privateGet(this, _abortController).abort();
    }
};
(_abortController = new WeakMap()),
    (_ProductRerender_instances = new WeakSet()),
    (onRerender_fn = function (e) {
        let t = deepQuerySelector(e.detail.htmlFragment, `#${this.id}`);
        if (!t) return;
        let i = document.activeElement;
        if (
            (!this.hasAttribute("allow-partial-rerender") || e.detail.productChange
                ? this.replaceWith(t)
                : ["meta", "payment-terms", "variant-picker", "inventory", "buy-buttons", "pickup-availability", "liquid"].forEach((e) => {
                      this.querySelectorAll(`[data-block-type="${e}"]`).forEach((i) => {
                          let n = t.querySelector(`[data-block-type="${e}"][data-block-id="${i.getAttribute("data-block-id")}"]`);
                          n && ("buy-buttons" === e ? i.querySelector("product-payment-container").replaceWith(n.querySelector("product-payment-container")) : i.replaceWith(n));
                      });
                  }),
            i.id)
        ) {
            let e = document.getElementById(i.id);
            this.contains(e) && e.focus();
        }
    }),
    window.customElements.get("product-rerender") || window.customElements.define("product-rerender", ProductRerender);
var PhotoSwipeUi = class {
        constructor(e) {
            (this.photoSwipeInstance = e),
                (this.delegate = new main_default(this.photoSwipeInstance.scrollWrap)),
                (this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2),
                (this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui")),
                this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this)),
                this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this)),
                this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this)),
                this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this)),
                this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this)),
                this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this)),
                this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this)),
                this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this)),
                this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this)),
                this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this)),
                this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
        }
        init() {
            let e = this.pswpUi.querySelector(".pswp__prev-next-buttons"),
                t = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
            if (this.photoSwipeInstance.items.length <= 1) return (e.style.display = "none"), void (t.style.display = "none");
            (e.style.display = ""), (t.style.display = "");
            let i = "";
            this.photoSwipeInstance.items.forEach((e, t) => {
                i += `\n        <button class="dots-nav__item tap-area" ${0 === t ? 'aria-current="true"' : ""} data-action="pswp-move-to">\n          <span class="visually-hidden">Go to slide ${t}</span>\n        </button>\n      `;
            }),
                (t.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = i);
        }
        _close() {
            this.photoSwipeInstance.close();
        }
        _goToPrev() {
            this.photoSwipeInstance.prev();
        }
        _goToNext() {
            this.photoSwipeInstance.next();
        }
        _moveTo(e, t) {
            this.photoSwipeInstance.goTo([...t.parentNode.children].indexOf(t));
        }
        _onPswpClosed() {
            this.delegate.off("pswpTap");
        }
        _onPswpDoubleTap(e) {
            let t = this.photoSwipeInstance.currItem.initialZoomLevel;
            this.photoSwipeInstance.getZoomLevel() !== t ? this.photoSwipeInstance.zoomTo(t, e, 333) : this.photoSwipeInstance.zoomTo(t < 0.7 ? 1 : this.maxSpreadZoom, e, 333);
        }
        _onPswpTap(e) {
            "mouse" === e.detail.pointerType && this.photoSwipeInstance.toggleDesktopZoom(e.detail.releasePoint);
        }
        _onPswpBeforeChange() {
            if (this.photoSwipeInstance.items.length <= 1) return;
            let e = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`);
            e.setAttribute("aria-current", "true"), getSiblings(e).forEach((e) => e.removeAttribute("aria-current"));
        }
        _onPswpInitialZoomInEnd() {
            this.pswpUi?.classList.remove("pswp__ui--hidden");
        }
        _onPswpInitialZoomOut() {
            this.pswpUi?.classList.add("pswp__ui--hidden");
        }
        _onPswpParseVerticalMargin(e) {
            e.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60;
        }
    },
    ProductImageZoom = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback(), (this.mediaElement = this.closest(".product__media")), (this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2), LibraryLoader.load("photoswipe");
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this.photoSwipeInstance?.destroy();
        }
        async attributeChangedCallback(e, t, i) {
            super.attributeChangedCallback(e, t, i), "open" === e && this.open && (await LibraryLoader.load("photoswipe"), this._openPhotoSwipe());
        }
        async _openPhotoSwipe() {
            let e = await this._buildItems();
            this.photoSwipeInstance = new window.ThemePhotoSwipe(this, PhotoSwipeUi, e, {
                index: e.findIndex((e) => e.selected),
                maxSpreadZoom: this.maxSpreadZoom,
                loop: !1,
                allowPanToNext: !1,
                closeOnScroll: !1,
                closeOnVerticalDrag: MediaFeatures.supportsHover(),
                showHideOpacity: !0,
                arrowKeys: !0,
                history: !1,
                getThumbBoundsFn: () => {
                    let e = this.mediaElement.querySelector(".product__media-item.is-selected"),
                        t = window.pageYOffset || document.documentElement.scrollTop,
                        i = e.getBoundingClientRect();
                    return { x: i.left, y: i.top + t, w: i.width };
                },
                getDoubleTapZoom: (e, t) => (e ? (t.w > t.h ? 1.6 : 1) : t.initialZoomLevel < 0.7 ? 1 : 1.33),
            });
            let t = null;
            (this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize, {
                apply(e, i, n) {
                    t !== window.innerWidth && (e(arguments), (t = window.innerWidth));
                },
            })),
                this.photoSwipeInstance.listen("close", () => {
                    this.open = !1;
                }),
                this.photoSwipeInstance.init();
        }
        async _buildItems() {
            let e = Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')),
                t = await ProductLoader.load(this.getAttribute("product-handle"));
            return Promise.resolve(
                e.map((e) => {
                    let i = t.media.find((t) => t.id === parseInt(e.getAttribute("data-media-id"))),
                        n = getSupportedSizes(i, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]),
                        s = Math.min(n[n.length - 1], window.innerWidth);
                    return {
                        selected: e.classList.contains("is-selected"),
                        src: getSizedMediaUrl(i, `${Math.ceil(Math.min(s * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`),
                        msrc: e.firstElementChild.currentSrc,
                        originalMedia: i,
                        w: s,
                        h: parseInt(s / i.aspect_ratio),
                    };
                })
            );
        }
    };
window.customElements.define("product-image-zoom", ProductImageZoom);
var KaqtuStockInfo = class extends HTMLElement {
    connectedCallback() {
        var e;
        let t = this.querySelector("script");
        t && ((this.inventories = JSON.parse(t.innerHTML)), null == (e = document.getElementById(this.getAttribute("form-id"))) || e.addEventListener("variant:changed", this._onVariantChanged.bind(this)));
    }
    _onVariantChanged(e) {
      var productVariantsVideoSections = document.querySelectorAll(".product-variants-video-section");
      if (productVariantsVideoSections.length) {
        productVariantsVideoSections.forEach(function(item) {
          var sectionVariantsItems = item.querySelectorAll(".variant-video");
          var videoWrapper = item.querySelector(".products-variants-video-section-wrapper");
          if (sectionVariantsItems.length) {
            sectionVariantsItems.forEach(function(el) {
              if (e.detail.variant.id == el.getAttribute('data-id')) {
                if (el.getAttribute('data-has-video') == 'false') {
                  item.style.display = 'none';
                } else {
                  item.style.display = '';
                  if (videoWrapper != null) {
                    videoWrapper.innerHTML = el.innerHTML;
                  }
                }
              }
            });
          }
        });
      }
        var t,
            i = document.querySelectorAll(".product-variants-meta-section-item");
        i.length &&
            i.forEach(function (t) {
                t.getAttribute("data-id") == e.detail.variant.id ? t.classList.add("active") : t.classList.remove("active");
            }),
            null == (t = this.querySelector("#kaqtu-stock-info-content")) || t.remove(),
            e.detail.variant && "" !== this.inventories[e.detail.variant.id] ? ((this.hidden = !1), this.insertAdjacentHTML("afterbegin", this.inventories[e.detail.variant.id])) : (this.hidden = !0);
    }
};
window.customElements.define("kaqtu-stock-info", KaqtuStockInfo);
var ProductForm = class extends HTMLFormElement {
    connectedCallback() {
        (this.id.disabled = !1), this.addEventListener("submit", this._onSubmit.bind(this));
    }
    async _onSubmit(e) {
        if ((e.preventDefault(), !this.checkValidity())) return void this.reportValidity();
        let t = Array.from(this.elements).filter((e) => "submit" === e.type);
        t.forEach((e) => {
            e.setAttribute("disabled", "disabled"), e.setAttribute("aria-busy", "true");
        });
        let i = new FormData(this);
        i.append("sections", ["mini-cart"]), i.delete("option1"), i.delete("option2"), i.delete("option3");
        let n = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, { body: i, method: "POST", headers: { "X-Requested-With": "XMLHttpRequest" } });
        t.forEach((e) => {
            e.removeAttribute("disabled"), e.removeAttribute("aria-busy");
        });
        let s = await n.json();
        if (n.ok) {
            if ("page" === window.themeVariables.settings.cartType || "cart" === window.themeVariables.settings.pageType) return (window.location.href = `${Shopify.routes.root}cart`);
            this.dispatchEvent(new CustomEvent("variant:added", { bubbles: !0, detail: { variant: s.hasOwnProperty("items") ? s.items[0] : s } })),
                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (e) => {
                    let t = await e.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: t } })),
                        (t.sections = s.sections),
                        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0, detail: { cart: t, openMiniCart: "drawer" === window.themeVariables.settings.cartType && null === this.closest(".drawer") } }));
                });
        }
        this.dispatchEvent(new CustomEvent("cart-notification:show", { bubbles: !0, cancelable: !0, detail: { status: n.ok ? "success" : "error", error: s.description || "" } }));
    }
};
window.customElements.define("product-form", ProductForm, { extends: "form" });
var ProductMedia = class extends CustomHTMLElement {
    async connectedCallback() {
        if (((this.mainCarousel = this.querySelector("flickity-carousel")), this.hasAttribute("reveal-on-scroll") && this._setupVisibility(), 1 === this.mainCarousel.childElementCount)) return;
        (this.selectedVariantMediaId = null),
            (this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]")),
            (this.zoomButton = this.querySelector(".product__zoom-button")),
            (this.product = await ProductLoader.load(this.getAttribute("product-handle")));
        let e = document.getElementById(this.getAttribute("form-id"));
        e?.addEventListener("variant:change", this._onVariantChanged.bind(this)),
            this.mainCarousel.addEventListener("model:played", () => this.mainCarousel.setDraggable(!1)),
            this.mainCarousel.addEventListener("model:paused", () => this.mainCarousel.setDraggable(!0)),
            this.mainCarousel.addEventListener("video:played", () => this.mainCarousel.setDraggable(!1)),
            this.mainCarousel.addEventListener("video:paused", () => this.mainCarousel.setDraggable(!0)),
            this.mainCarousel.addEventListener("flickity:ready", this._onFlickityReady.bind(this)),
            this.mainCarousel.addEventListener("flickity:slide-changed", this._onFlickityChanged.bind(this)),
            this.mainCarousel.addEventListener("flickity:slide-settled", this._onFlickitySettled.bind(this)),
            this._onFlickityReady();
    }
    get thumbnailsPosition() {
        return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? "bottom" : this.getAttribute("thumbnails-position");
    }
    async _setupVisibility() {
        await this.untilVisible();
        let e = await this.mainCarousel.flickityInstance,
            t = e ? e.selectedElement.querySelector("img") : this.querySelector(".product__media-image-wrapper img"),
            i = MediaFeatures.prefersReducedMotion();
        await imageLoaded(t);
        let n = new CustomAnimation(
            new ParallelEffect([
                new CustomKeyframeEffect(t, { opacity: [0, 1], transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
                new ParallelEffect(
                    Array.from(this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")).map(
                        (e, t) =>
                            new CustomKeyframeEffect(
                                e,
                                { opacity: [0, 1], transform: "left" === this.thumbnailsPosition ? [`translateY(${i ? 0 : "40px"})`, "translateY(0)"] : [`translateX(${i ? 0 : "50px"})`, "translateX(0)"] },
                                { duration: 250, delay: i ? 0 : 100 * t, easing: "cubic-bezier(0.75, 0, 0.175, 1)" }
                            )
                    )
                ),
            ])
        );
        this._hasSectionReloaded ? n.finish() : n.play();
    }
    async _onVariantChanged(e) {
        let t = e.detail.variant,
            i = [],
            n = !1;
        if (
            (this.product.media.forEach((e) => {
                let s = t.featured_media && e.id === t.featured_media.id;
                if (e.alt?.includes("#") && ((n = !0), !s)) {
                    let n = e.alt.split("#").pop().split("_");
                    this.product.options.forEach((s) => {
                        s.name.toLowerCase() === n[0].toLowerCase() && t.options[s.position - 1].toLowerCase() !== n[1].trim().toLowerCase() && i.push(e.id);
                    });
                }
            }),
            [...new Set(Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map((e) => parseInt(e.getAttribute("data-media-id"))))].some((e) => !i.includes(e)))
        ) {
            let e = t.featured_media ? t.featured_media.id : this.product.media.map((e) => e.id).filter((e) => !i.includes(e))[0];
            (await this.mainCarousel.flickityInstance).destroy(),
                Array.from(this.querySelectorAll("[data-media-id]")).forEach((t) => {
                    t.classList.toggle("is-filtered", i.includes(parseInt(t.getAttribute("data-media-id")))),
                        t.classList.toggle("is-selected", e === parseInt(t.getAttribute("data-media-id"))),
                        t.classList.toggle("is-initial-selected", e === parseInt(t.getAttribute("data-media-id")));
                }),
                this.mainCarousel.reload();
        } else {
            if (!e.detail.variant.featured_media || this.selectedVariantMediaId === e.detail.variant.featured_media.id) return;
            this.mainCarousel.select(`[data-media-id="${e.detail.variant.featured_media.id}"]`);
        }
        this.selectedVariantMediaId = e.detail.variant.featured_media ? e.detail.variant.featured_media.id : null;
    }
    async _onFlickityReady() {
        let e = await this.mainCarousel.flickityInstance;
        ["video", "external_video"].includes(e.selectedElement.getAttribute("data-media-type")) && this.hasAttribute("autoplay-video") && e.selectedElement.firstElementChild.play();
    }
    async _onFlickityChanged() {
        (await this.mainCarousel.flickityInstance).cells.forEach((e) => {
            ["external_video", "video", "model"].includes(e.element.getAttribute("data-media-type")) && e.element.firstElementChild.pause();
        });
    }
    async _onFlickitySettled() {
        let e = (await this.mainCarousel.flickityInstance).selectedElement;
        switch (
            (this.zoomButton && (this.zoomButton.hidden = "image" !== e.getAttribute("data-media-type")),
            this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id")),
            e.getAttribute("data-media-type"))
        ) {
            case "model":
                this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", e.getAttribute("data-media-id")), e.firstElementChild.play();
                break;
            case "external_video":
            case "video":
                this.hasAttribute("autoplay-video") && e.firstElementChild.play();
        }
    }
};
window.customElements.define("product-media", ProductMedia);
var QuickBuyDrawer = class extends DrawerContent {
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("openable-element:close", this._onClose.bind(this));
    }
    async _load() {
        if (!this.requiresLoading) return;
        triggerNonBubblingEvent(this, "openable-element:load:start");
        let e = await fetch(this.getAttribute("href")),
            t = document
                .createRange()
                .createContextualFragment(await e.text())
                .querySelector("#quick-buy-content")
                .content.querySelector("quick-buy-drawer");
        this.replaceChildren(...t.children), triggerNonBubblingEvent(this, "openable-element:load:end"), window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
    }
    async _onClose() {
        this.addEventListener(
            "transitionend",
            (e) => {
                this.innerHTML = "";
            },
            { once: !0 }
        );
    }
};
window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
var QuickBuyPopover = class extends PopoverContent {
    connectedCallback() {
        super.connectedCallback(), this.delegate.on("variant:added", () => (this.open = !1)), this.addEventListener("openable-element:close", this._onClose.bind(this));
    }
    async _load() {
        if (!this.requiresLoading) return;
        triggerNonBubblingEvent(this, "openable-element:load:start");
        let e = await fetch(this.getAttribute("href")),
            t = document
                .createRange()
                .createContextualFragment(await e.text())
                .querySelector("#quick-buy-content")
                .content.querySelector("quick-buy-popover");
        this.replaceChildren(...t.children), triggerNonBubblingEvent(this, "openable-element:load:end"), window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
    }
    async _onClose() {
        this.addEventListener(
            "transitionend",
            (e) => {
                this.innerHTML = "";
            },
            { once: !0 }
        );
    }
};
window.customElements.define("quick-buy-popover", QuickBuyPopover);
var _preloadedHtml,
    _delegate,
    _intersectionObserver,
    _form,
    _selectedVariant,
    _VariantPicker_instances,
    getActiveOptionValues_fn,
    getOptionValuesFromOption_fn,
    onOptionChanged_fn,
    onOptionPreload_fn,
    onIntersection_fn,
    renderForCombination_fn,
    createHashKeyForHtml_fn,
    CACHE_EVICTION_TIME = 3e5,
    _VariantPicker = class extends HTMLElement {
        constructor() {
            super(...arguments),
                __privateAdd(this, _VariantPicker_instances),
                __privateAdd(this, _delegate, new main_default(document.body)),
                __privateAdd(this, _intersectionObserver, new IntersectionObserver(__privateMethod(this, _VariantPicker_instances, onIntersection_fn).bind(this))),
                __privateAdd(this, _form),
                __privateAdd(this, _selectedVariant);
        }
        async connectedCallback() {
            __privateSet(this, _selectedVariant, JSON.parse(this.querySelector("script[data-variant]")?.textContent || "{}")),
                __privateSet(this, _form, document.forms[this.getAttribute("form-id")]),
                __privateGet(this, _delegate).on(
                    "change",
                    `input[data-option-position][form="${this.getAttribute("form-id")}"], select[data-option-position][form="${this.getAttribute("form-id")}"]`,
                    __privateMethod(this, _VariantPicker_instances, onOptionChanged_fn).bind(this)
                ),
                __privateGet(this, _delegate).on(
                    "pointerenter",
                    `input[data-option-position][form="${this.getAttribute("form-id")}"]:not(:checked) + label`,
                    __privateMethod(this, _VariantPicker_instances, onOptionPreload_fn).bind(this),
                    !0
                ),
                __privateGet(this, _delegate).on("touchstart", `input[data-option-position][form="${this.getAttribute("form-id")}"]:not(:checked) + label`, __privateMethod(this, _VariantPicker_instances, onOptionPreload_fn).bind(this), !0),
                __privateGet(this, _intersectionObserver).observe(this);
        }
        disconnectedCallback() {
            __privateGet(this, _delegate).off(), __privateGet(this, _intersectionObserver).unobserve(this);
        }
        get selectedVariant() {
            return __privateGet(this, _selectedVariant);
        }
        get productHandle() {
            return this.getAttribute("handle");
        }
        get updateUrl() {
            return this.hasAttribute("update-url");
        }
        async selectCombination({ optionValues: e, productChange: t }) {
            let i = this.selectedVariant,
                n = document.createRange().createContextualFragment(await __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, e));
            if (!t) {
                let e = deepQuerySelector(n, `${this.tagName}[form-id="${this.getAttribute("form-id")}"]`),
                    t = JSON.parse(e.querySelector("script[data-variant]")?.textContent || "{}");
                if (
                    (__privateSet(this, _selectedVariant, t),
                    (__privateGet(this, _form).id.value = __privateGet(this, _selectedVariant)?.id),
                    __privateGet(this, _form).id.dispatchEvent(new Event("change", { bubbles: !0 })),
                    this.updateUrl && __privateGet(this, _selectedVariant)?.id)
                ) {
                    let e = new URL(window.location.href);
                    e.searchParams.set("variant", __privateGet(this, _selectedVariant).id), window.history.replaceState({ path: e.toString() }, "", e.toString());
                }
                __privateGet(this, _form).dispatchEvent(new CustomEvent("variant:change", { bubbles: !0, detail: { formId: __privateGet(this, _form).id, variant: __privateGet(this, _selectedVariant), previousVariant: i } })),
                    __privateGet(this, _form).dispatchEvent(new CustomEvent("variant:changed", { bubbles: !0, detail: { formId: __privateGet(this, _form).id, variant: __privateGet(this, _selectedVariant), previousVariant: i } }));
            }
            __privateGet(this, _form).dispatchEvent(new CustomEvent("product:rerender", { detail: { htmlFragment: n, productChange: t } })), Shopify?.PaymentButton?.init();
        }
    };
(_preloadedHtml = new WeakMap()),
    (_delegate = new WeakMap()),
    (_intersectionObserver = new WeakMap()),
    (_form = new WeakMap()),
    (_selectedVariant = new WeakMap()),
    (_VariantPicker_instances = new WeakSet()),
    (getActiveOptionValues_fn = function () {
        return Array.from(__privateGet(this, _form).elements)
            .filter((e) => e.matches('input[data-option-position]:checked, input[data-option-position][type="hidden"]'))
            .sort((e, t) => parseInt(e.getAttribute("data-option-position")) - parseInt(t.getAttribute("data-option-position")))
            .map((e) => e.value);
    }),
    (getOptionValuesFromOption_fn = function (e) {
        return [e, ...Array.from(__privateGet(this, _form).elements).filter((t) => t.matches(`input[data-option-position]:not([name="${e.name}"]):checked, input[data-option-position]:not([name="${e.name}"])[type="hidden"]`))]
            .sort((e, t) => parseInt(e.getAttribute("data-option-position")) - parseInt(t.getAttribute("data-option-position")))
            .map((e) => e.value);
    }),
    (onOptionChanged_fn = async function (e) {
        e.target.name.includes("option") && this.selectCombination({ optionValues: __privateMethod(this, _VariantPicker_instances, getActiveOptionValues_fn).call(this), productChange: e.target.hasAttribute("data-product-url") });
    }),
    (onOptionPreload_fn = function (e, t) {
        __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, __privateMethod(this, _VariantPicker_instances, getOptionValuesFromOption_fn).call(this, t.control));
    }),
    (onIntersection_fn = function (e) {
        let t = () => {
            Array.from(__privateGet(this, _form).elements)
                .filter((e) => e.matches('input[data-option-position]:not(:checked), input[data-option-position][type="hidden"]'))
                .forEach((e) => {
                    __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, __privateMethod(this, _VariantPicker_instances, getOptionValuesFromOption_fn).call(this, e));
                });
        };
        e[0].isIntersecting && (window.requestIdleCallback ? window.requestIdleCallback(t, { timeout: 2e3 }) : t());
    }),
    (renderForCombination_fn = async function (e) {
        let t = e.join(","),
            i = __privateMethod(this, _VariantPicker_instances, createHashKeyForHtml_fn).call(this, t),
            n = `${Shopify.routes.root}products/${this.productHandle}`;
        for (let t of e) {
            let e = Array.from(__privateGet(this, _form).elements).find((e) => e.matches(`input[value="${t}"]`));
            if (e?.dataset.productUrl) {
                n = e.dataset.productUrl;
                break;
            }
        }
        if (!__privateGet(_VariantPicker, _preloadedHtml).has(i)) {
            let e = "quick_buy" === this.getAttribute("context") ? "" : `&section_id=${this.getAttribute("section-id")}`,
                s = new Promise(async (i) => {
                    i(await (await fetch(`${n}?option_values=${t}${e}`)).text());
                });
            __privateGet(_VariantPicker, _preloadedHtml).set(i, { htmlPromise: s, timestamp: Date.now() }),
                __privateGet(_VariantPicker, _preloadedHtml).size > 100 && __privateGet(_VariantPicker, _preloadedHtml).delete(Array.from(__privateGet(_VariantPicker, _preloadedHtml).keys())[0]);
        }
        return __privateGet(_VariantPicker, _preloadedHtml).get(i).htmlPromise;
    }),
    (createHashKeyForHtml_fn = function (e) {
        return `${e}-${this.getAttribute("section-id")}`;
    }),
    __privateAdd(_VariantPicker, _preloadedHtml, new Map());
var VariantPicker = _VariantPicker;
window.customElements.get("variant-picker") || window.customElements.define("variant-picker", VariantPicker);
var ProductItem = class extends CustomHTMLElement {
    connectedCallback() {
        (this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"))),
            this.delegate.on("change", ".product-item-meta__swatch-list .color-swatch__radio", this._onColorSwatchChanged.bind(this)),
            this.delegate.on("mouseenter", ".product-item-meta__swatch-list .color-swatch__item", this._onColorSwatchHovered.bind(this), !0);
    }
    async _onColorSwatchChanged(e, t) {
        if (
            (Array.from(this.querySelectorAll('[href*="/products"]')).forEach((e) => {
                let i;
                (i = "A" === e.tagName ? new URL(e.href) : new URL(e.getAttribute("href"), `https://${window.themeVariables.routes.host}`)).searchParams.set("variant", t.getAttribute("data-variant-id")),
                    e.setAttribute("href", i.toString());
            }),
            t.hasAttribute("data-variant-featured-media"))
        ) {
            let e = this.primaryImageList.find((e) => e.getAttribute("data-media-id") === t.getAttribute("data-variant-featured-media"));
            e.setAttribute("loading", "eager");
            let i = e.complete ? Promise.resolve() : new Promise((t) => (e.onload = t));
            await i, e.removeAttribute("hidden");
            let n = {};
            await e.animate(
                (n = Array.from(e.parentElement.classList).some((e) => ["aspect-ratio--short", "aspect-ratio--tall", "aspect-ratio--square"].includes(e))
                    ? [
                          { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0 },
                          { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0.3 },
                          { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translate(-50%, -50%)", zIndex: 1, offset: 1 },
                      ]
                    : [
                          { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0 },
                          { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0.3 },
                          { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translateX(0px)", zIndex: 1, offset: 1 },
                      ]),
                { duration: 500, easing: "ease-in-out" }
            ).finished,
                this.primaryImageList.filter((t) => t.classList.contains("product-item__primary-image") && t !== e).forEach((e) => e.setAttribute("hidden", ""));
        }
    }
    _onColorSwatchHovered(e, t) {
        let i = t.previousElementSibling;
        i.hasAttribute("data-variant-featured-media") && this.primaryImageList.find((e) => e.getAttribute("data-media-id") === i.getAttribute("data-variant-featured-media")).setAttribute("loading", "eager");
    }
};
window.customElements.define("product-item", ProductItem);
var ProductFacet = class extends CustomHTMLElement {
    connectedCallback() {
        this.delegate.on("pagination:page-changed", this._rerender.bind(this)), this.delegate.on("facet:criteria-changed", this._rerender.bind(this)), this.delegate.on("facet:abort-loading", this._abort.bind(this));
    }
    async _rerender(e) {
        history.replaceState({}, "", e.detail.url), this._abort(), this.showLoadingBar();
        let t = new URL(window.location);
        t.searchParams.set("section_id", this.getAttribute("section-id"));
        try {
            this.abortController = new AbortController();
            let e = await fetch(t.toString(), { signal: this.abortController.signal }),
                i = await e.text(),
                n = document.createElement("div");
            (n.innerHTML = i), (this.querySelector("#facet-main").innerHTML = n.querySelector("#facet-main").innerHTML);
            let s = Array.from(n.querySelectorAll(".product-facet__active-list")),
                a = document.querySelector(".mobile-toolbar__item--filters");
            a && a.classList.toggle("has-filters", s.length > 0);
            let r = n.querySelector("#facet-filters");
            if (r) {
                let e = this.querySelector("#facet-filters .drawer__content").scrollTop;
                Array.from(this.querySelectorAll("#facet-filters-form .collapsible-toggle[aria-controls]")).forEach((e) => {
                    let t = r.querySelector(`[aria-controls="${e.getAttribute("aria-controls")}"]`),
                        i = "true" === e.getAttribute("aria-expanded");
                    t && (t.setAttribute("aria-expanded", i ? "true" : "false"), t.nextElementSibling.toggleAttribute("open", i), (t.nextElementSibling.style.overflow = i ? "visible" : ""));
                }),
                    (this.querySelector("#facet-filters").innerHTML = r.innerHTML),
                    (this.querySelector("#facet-filters .drawer__content").scrollTop = e);
            }
            let o = this.querySelector(".product-facet__meta-bar") || this.querySelector(".product-facet__product-list") || this.querySelector(".product-facet__main");
            requestAnimationFrame(() => {
                o.scrollIntoView({ block: "start", behavior: "smooth" });
            }),
                this.hideLoadingBar();
        } catch (e) {
            if ("AbortError" === e.name) return;
        }
    }
    _abort() {
        this.abortController && this.abortController.abort();
    }
};
window.customElements.define("product-facet", ProductFacet);
var FacetFilters = class extends DrawerContent {
    connectedCallback() {
        super.connectedCallback(),
            this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)),
            this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this)),
            this.alwaysVisible && ((this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket)), this.matchMedia.addListener(this._adjustDrawer.bind(this)), this._adjustDrawer(this.matchMedia));
    }
    get alwaysVisible() {
        return this.hasAttribute("always-visible");
    }
    _onFiltersCleared(e, t) {
        e.preventDefault(), triggerEvent(this, "facet:criteria-changed", { url: t.href });
    }
    _onFilterChanged() {
        let e = new FormData(this.querySelector("#facet-filters-form")),
            t = new URLSearchParams(e).toString();
        triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${t}` });
    }
    _adjustDrawer(e) {
        this.classList.toggle("drawer", e.matches), this.classList.toggle("drawer--from-left", e.matches);
    }
};
window.customElements.define("facet-filters", FacetFilters);
var SortByPopover = class extends PopoverContent {
    connectedCallback() {
        super.connectedCallback(), this.delegate.on("change", '[name="sort_by"]', this._onSortChanged.bind(this));
    }
    _onSortChanged(e, t) {
        let i = new URL(location.href);
        i.searchParams.set("sort_by", t.value), i.searchParams.delete("page"), (this.open = !1), this.dispatchEvent(new CustomEvent("facet:criteria-changed", { bubbles: !0, detail: { url: i.toString() } }));
    }
};
window.customElements.define("sort-by-popover", SortByPopover);
var CartCount = class extends CustomHTMLElement {
    connectedCallback() {
        this.rootDelegate.on("cart:updated", (e) => (this.innerText = e.detail.cart.item_count)), this.rootDelegate.on("cart:refresh", this._updateCartCount.bind(this));
    }
    _updateCartCount(e) {
        e?.detail?.cart
            ? (this.innerText = e.detail.cart.item_count)
            : fetch(Shopify.routes.root + "cart.js").then((e) => {
                  e.json().then((e) => {
                      this.innerText = e.item_count;
                  });
              });
    }
};
window.customElements.define("cart-count", CartCount);
var CartDrawer = class extends DrawerContent {
    connectedCallback() {
        super.connectedCallback(), (this.nextReplacementDelay = 0), this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this)), this.addEventListener("variant:added", () => (this.nextReplacementDelay = 600));
    }
    async _rerenderCart(e) {
        let t = null,
            i = "";
        if (e.detail && e.detail.cart && e.detail.cart.sections) (t = e.detail.cart), (i = e.detail.cart.sections["mini-cart"]);
        else {
            let e = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute("section")}`);
            i = await e.text();
        }
        let n = document.createElement("div");
        (n.innerHTML = i),
            setTimeout(async () => {
                let i = this.querySelector(".drawer__content").scrollTop;
                if (t && 0 === t.item_count) {
                    let e = new CustomAnimation(new ParallelEffect(Array.from(this.querySelectorAll(".drawer__content, .drawer__footer")).map((e) => new CustomKeyframeEffect(e, { opacity: [1, 0] }, { duration: 250, easing: "ease-in" }))));
                    e.play(), await e.finished;
                }
                (this.innerHTML = n.querySelector("cart-drawer").innerHTML),
                    t && 0 === t.item_count
                        ? this.querySelector(".drawer__content").animate({ opacity: [0, 1], transform: ["translateY(40px)", "translateY(0)"] }, { duration: 450, easing: "cubic-bezier(0.33, 1, 0.68, 1)" })
                        : (this.querySelector(".drawer__content").scrollTop = i),
                    e?.detail?.openMiniCart && (this.clientWidth, (this.open = !0));
            }, e?.detail?.replacementDelay || this.nextReplacementDelay),
            (this.nextReplacementDelay = 0);
    }
    async attributeChangedCallback(e, t, i) {
        if ((super.attributeChangedCallback(e, t, i), "open" === e && this.open && ((this.querySelector(".drawer__content").scrollTop = 0), !MediaFeatures.prefersReducedMotion()))) {
            let e = Array.from(this.querySelectorAll(".line-item")),
                t = this.querySelector(".mini-cart__recommendations-inner"),
                i = this.querySelector(".drawer__footer"),
                n = [];
            t && window.matchMedia(window.themeVariables.breakpoints.pocket).matches && e.push(t),
                e.forEach((e) => (e.style.opacity = 0)),
                t && (t.style.opacity = 0),
                i && (i.style.opacity = 0),
                n.push(
                    new ParallelEffect(
                        e.map(
                            (e, t) =>
                                new CustomKeyframeEffect(
                                    e,
                                    { opacity: [0, 1], transform: ["translateX(40px)", "translateX(0)"] },
                                    { duration: 400, delay: 400 + 120 * t - Math.min(2 * t * t, 120 * t), easing: "cubic-bezier(0.25, 1, 0.5, 1)" }
                                )
                        )
                    )
                ),
                i && n.push(new CustomKeyframeEffect(i, { opacity: [0, 1], transform: ["translateY(100%)", "translateY(0)"] }, { duration: 300, delay: 400, easing: "cubic-bezier(0.25, 1, 0.5, 1)" })),
                t &&
                    !window.matchMedia(window.themeVariables.breakpoints.pocket).matches &&
                    n.push(
                        new CustomKeyframeEffect(
                            t,
                            { opacity: [0, 1], transform: ["translateX(100%)", "translateX(0)"] },
                            { duration: 250, delay: 400 + Math.max(120 * e.length - 25 * e.length, 25), easing: "cubic-bezier(0.25, 1, 0.5, 1)" }
                        )
                    ),
                new CustomAnimation(new ParallelEffect(n)).play();
        }
    }
};
window.customElements.define("cart-drawer", CartDrawer);
var _CartDrawerRecommendations = class e extends HTMLElement {
    async connectedCallback() {
        e.recommendationsCache[this.productId] || (e.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`));
        let t = await e.recommendationsCache[this.productId],
            i = document.createElement("div");
        i.innerHTML = await t.clone().text();
        let n = i.querySelector("cart-drawer-recommendations");
        n && n.hasChildNodes() ? (this.innerHTML = n.innerHTML) : (this.hidden = !0);
    }
    get productId() {
        return this.getAttribute("product-id");
    }
    get sectionId() {
        return this.getAttribute("section-id");
    }
};
__publicField(_CartDrawerRecommendations, "recommendationsCache", {});
var CartDrawerRecommendations = _CartDrawerRecommendations;
window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
var CartNote = class extends HTMLTextAreaElement {
    connectedCallback() {
        this.addEventListener("change", this._onNoteChanged.bind(this));
    }
    get ownedToggle() {
        return this.hasAttribute("aria-owns") ? document.getElementById(this.getAttribute("aria-owns")) : null;
    }
    async _onNoteChanged() {
        this.ownedToggle && (this.ownedToggle.innerHTML = "" === this.value ? window.themeVariables.strings.cartAddOrderNote : window.themeVariables.strings.cartEditOrderNote);
        let e = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, { body: JSON.stringify({ note: this.value }), credentials: "same-origin", method: "POST", headers: { "Content-Type": "application/json" } }),
            t = await e.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: t } }));
    }
};
window.customElements.define("cart-note", CartNote, { extends: "textarea" });
var FreeShippingBar = class extends HTMLElement {
    connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
    }
    get threshold() {
        return parseFloat(this.getAttribute("threshold"));
    }
    _onCartUpdated(e) {
        let t = e.detail.cart.items.filter((e) => e.requires_shipping).reduce((e, t) => e + t.final_line_price, 0);
        this.style.setProperty("--progress", Math.min(t / this.threshold, 1));
    }
};
window.customElements.define("free-shipping-bar", FreeShippingBar);
var LineItemQuantity = class extends CustomHTMLElement {
    connectedCallback() {
        this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this)), this.delegate.on("change", "input", this._onQuantityChanged.bind(this));
    }
    _onQuantityLinkClicked(e, t) {
        e.preventDefault(), this._updateFromLink(t.href);
    }
    _onQuantityChanged(e, t) {
        this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${t.value}&line=${t.getAttribute("data-line")}`);
    }
    async _updateFromLink(e) {
        if ("cart" === window.themeVariables.settings.pageType) return void (window.location.href = e);
        let t = new URL(e, `https://${window.themeVariables.routes.host}`).searchParams,
            i = t.get("line"),
            n = t.get("id"),
            s = parseInt(t.get("quantity"));
        this.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: !0, detail: { newLineQuantity: s } }));
        let a = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
            body: JSON.stringify({ line: i, id: n, quantity: s, sections: ["mini-cart"] }),
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
        if (a.ok) {
            let e = await a.json();
            this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: !0, detail: { cart: e, newLineQuantity: s } })),
                document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: e } })),
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: !0, detail: { cart: e, replacementDelay: 0 === s ? 600 : 750 } }));
        } else this.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: !0 }));
    }
};
window.customElements.define("line-item-quantity", LineItemQuantity);
var LineItem = class extends HTMLElement {
    connectedCallback() {
        (this.lineItemLoader = this.querySelector(".line-item__loader")),
            this.addEventListener("line-item-quantity:change:start", this._onQuantityStart.bind(this)),
            this.addEventListener("line-item-quantity:change:end", this._onQuantityEnd.bind(this));
    }
    _onQuantityStart() {
        this.lineItemLoader && ((this.lineItemLoader.hidden = !1), (this.lineItemLoader.firstElementChild.hidden = !1), (this.lineItemLoader.lastElementChild.hidden = !0));
    }
    async _onQuantityEnd(e) {
        0 !== e?.detail?.cart.item_count &&
            this.lineItemLoader &&
            (await this.lineItemLoader.firstElementChild.animate({ opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, 75).finished,
            (this.lineItemLoader.firstElementChild.hidden = !0),
            0 === e?.detail?.newLineQuantity
                ? (await this.animate({ opacity: [1, 0], height: [`${this.clientHeight}px`, 0] }, { duration: 300, easing: "ease" }).finished, this.remove())
                : ((this.lineItemLoader.lastElementChild.hidden = !1),
                  await this.lineItemLoader.lastElementChild.animate({ opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 75, endDelay: 300 }).finished,
                  (this.lineItemLoader.hidden = !0)));
    }
};
window.customElements.define("line-item", LineItem);
var CartNotification = class extends CustomHTMLElement {
    connectedCallback() {
        this.rootDelegate.on("cart-notification:show", this._onShow.bind(this), !this.hasAttribute("global")),
            this.delegate.on("click", '[data-action="close"]', (e) => {
                e.stopPropagation(), (this.hidden = !0);
            }),
            this.addEventListener("mouseenter", this.stopTimer.bind(this)),
            this.addEventListener("mouseleave", this.startTimer.bind(this)),
            window.addEventListener("pagehide", () => (this.hidden = !0));
    }
    set hidden(e) {
        e ? this.stopTimer() : this.startTimer(), this.toggleAttribute("hidden", e);
    }
    get isInsideDrawer() {
        return this.classList.contains("cart-notification--drawer");
    }
    stopTimer() {
        clearTimeout(this._timeout);
    }
    startTimer() {
        this._timeout = setTimeout(() => (this.hidden = !0), 3e3);
    }
    _onShow(e) {
        if ((this.isInsideDrawer && !this.closest(".drawer").open) || (this.hasAttribute("global") && "success" === e.detail.status && "drawer" === window.themeVariables.settings.cartType)) return;
        e.stopPropagation();
        let t = "";
        this.isInsideDrawer ||
            (t = `\n        <button class="cart-notification__close tap-area hidden-phone" data-action="close">\n          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>\n          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">\n            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>\n          </svg>\n        </button>\n      `),
            "success" === e.detail.status
                ? (this.classList.remove("cart-notification--error"),
                  (this.innerHTML = `\n        <div class="cart-notification__overflow">\n          <div class="container">\n            <div class="cart-notification__wrapper">\n              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">\n                <rect width="20" height="20" rx="10" fill="currentColor"></rect>\n                <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>\n              </svg>\n              \n              <div class="cart-notification__text-wrapper">\n                <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>\n                <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>\n                <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link" data-no-instant>${window.themeVariables.strings.cartViewCart}</a>\n              </div>\n              \n              ${t}\n            </div>\n          </div>\n        </div>\n      `))
                : (this.classList.add("cart-notification--error"),
                  (this.innerHTML = `\n        <div class="cart-notification__overflow">\n          <div class="container">\n            <div class="cart-notification__wrapper">\n              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">\n                <rect width="20" height="20" rx="10" fill="currentColor"></rect>\n                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>\n              </svg>\n              \n              <div class="cart-notification__text-wrapper">\n                <span class="cart-notification__heading heading">${e.detail.error}</span>\n              </div>\n              \n              ${t}\n            </div>\n          </div>\n        </div>\n      `)),
            this.clientHeight,
            (this.hidden = !1);
    }
};
function formatMoney(e, t = "") {
    "string" == typeof e && (e = e.replace(".", ""));
    let i = /\{\{\s*(\w+)\s*\}\}/,
        n = t || window.themeVariables.settings.moneyFormat;
    function s(e, t) {
        return null == e || e != e ? t : e;
    }
    function a(e, t, i, n) {
        if (((t = s(t, 2)), (i = s(i, ",")), (n = s(n, ".")), isNaN(e) || null == e)) return 0;
        let a = (e = (e / 100).toFixed(t)).split(".");
        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "");
    }
    let r = "";
    switch (n.match(i)[1]) {
        case "amount":
            r = a(e, 2);
            break;
        case "amount_no_decimals":
            r = a(e, 0);
            break;
        case "amount_with_space_separator":
            r = a(e, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            r = a(e, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            r = a(e, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            r = a(e, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            r = a(e, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            r = a(e, 0, "'");
    }
    return n.indexOf("with_comma_separator"), n.replace(i, r);
}
window.customElements.define("cart-notification", CartNotification);
var ShippingEstimator = class extends HTMLElement {
    connectedCallback() {
        (this.submitButton = this.querySelector('[type="button"]')), this.submitButton.addEventListener("click", this._estimateShipping.bind(this));
    }
    async _estimateShipping() {
        let e = this.querySelector('[name="shipping-estimator[zip]"]').value,
            t = this.querySelector('[name="shipping-estimator[country]"]').value,
            i = this.querySelector('[name="shipping-estimator[province]"]').value;
        this.submitButton.setAttribute("aria-busy", "true");
        let n = await fetch(`${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`, { method: "POST" });
        if (n.ok) {
            let n = await this._getAsyncShippingRates(e, t, i);
            this._formatShippingRates(n);
        } else {
            let e = await n.json();
            this._formatError(e);
        }
        this.submitButton.removeAttribute("aria-busy");
    }
    async _getAsyncShippingRates(e, t, i) {
        let n = await fetch(`${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`),
            s = await n.text();
        return "null" === s ? this._getAsyncShippingRates(e, t, i) : JSON.parse(s).shipping_rates;
    }
    _formatShippingRates(e) {
        this.querySelector(".shipping-estimator__results")?.remove();
        let t = "";
        e.forEach((e) => {
            t += `<li>${e.presentment_name}: ${formatMoney(100 * parseFloat(e.price))}</li>`;
        });
        let i = `\n      <div class="shipping-estimator__results">\n        <p>${
            0 === e.length ? window.themeVariables.strings.shippingEstimatorNoResults : 1 === e.length ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults
        }</p>\n        ${"" === t ? "" : `<ul class="unordered-list">${t}</ul>`}\n      </div>\n    `;
        this.insertAdjacentHTML("beforeend", i);
    }
    _formatError(e) {
        this.querySelector(".shipping-estimator__results")?.remove();
        let t = "";
        Object.keys(e).forEach((i) => {
            t += `<li>${i} ${e[i]}</li>`;
        });
        let i = `\n      <div class="shipping-estimator__results">\n        <p>${window.themeVariables.strings.shippingEstimatorError}</p>\n        <ul class="unordered-list">${t}</ul>\n      </div>\n    `;
        this.insertAdjacentHTML("beforeend", i);
    }
};
window.customElements.define("shipping-estimator", ShippingEstimator);
var ReviewLink = class extends HTMLAnchorElement {
    constructor() {
        super(), this.addEventListener("click", this._onClick.bind(this));
    }
    _onClick() {
        let e = document.getElementById("shopify-product-reviews");
        e && (window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? (e.closest("collapsible-content").open = !0) : document.querySelector(`[aria-controls="${e.closest(".product-tabs__tab-item-wrapper").id}"]`).click());
    }
};
window.customElements.define("review-link", ReviewLink, { extends: "a" });
var ProductStickyForm = class extends HTMLElement {
    _delegate = new main_default(this);
    connectedCallback() {
        this._setupVisibilityObservers(), this._delegate.on("change", "select[data-option-position]", this._syncMainForm.bind(this));
    }
    disconnectedCallback() {
        this.intersectionObserver.disconnect();
    }
    set hidden(e) {
        this.toggleAttribute("hidden", e), e ? document.documentElement.style.removeProperty("--cart-notification-offset") : document.documentElement.style.setProperty("--cart-notification-offset", `${this.clientHeight}px`);
    }
    _syncMainForm(e) {
        let t = document.forms[this.getAttribute("form-id")];
        for (let i of t.elements) i.name === e.target.name && "INPUT" === i.tagName && (i.checked = i.value = e.target.value);
    }
    _setupVisibilityObservers() {
        let e = document.getElementById("MainPaymentContainer").closest("form"),
            t = document.querySelector(".shopify-section--footer"),
            i = getStickyHeaderOffset();
        (this._isFooterVisible = this._isPaymentContainerPassed = !1),
            (this.intersectionObserver = new IntersectionObserver(
                (n) => {
                    n.forEach((n) => {
                        if ((n.target === t && (this._isFooterVisible = n.intersectionRatio > 0), n.target === e)) {
                            let t = e.getBoundingClientRect();
                            this._isPaymentContainerPassed = 0 === n.intersectionRatio && t.top + t.height <= i;
                        }
                    }),
                        window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? (this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible) : (this.hidden = !this._isPaymentContainerPassed);
                },
                { rootMargin: `-${i}px 0px 0px 0px` }
            )),
            this.intersectionObserver.observe(e),
            this.intersectionObserver.observe(t);
    }
};
window.customElements.define("product-sticky-form", ProductStickyForm),
    new InputBindingManager(),
    Shopify.designMode &&
        document.addEventListener("shopify:section:load", () => {
            window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts());
        }),
    (window.SPRCallbacks = {
        onFormSuccess(e, t) {
            document.getElementById(`form_${t.id}`).classList.add("spr-form--success");
        },
    }),
    (() => {
        let e = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth,
            t = () => {
                let t = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth,
                    i = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
                t !== e &&
                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty("--window-height", i + "px"), (e = t);
                    });
            };
        t(), window.visualViewport ? window.visualViewport.addEventListener("resize", t) : window.addEventListener("resize", t);
    })(),
    (() => {
        let e = new main_default(document.body);
        e.on("change", 'input:not([type="checkbox"]):not([type="radio"]), textarea', (e, t) => {
            t.classList.toggle("is-filled", "" !== t.value);
        }),
            e.on("change", "select", (e, t) => {
                t.parentNode.classList.toggle("is-filled", "" !== t.value);
            });
    })(),
    document.querySelectorAll(".rte table").forEach((e) => {
        e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
    }),
    document.querySelectorAll(".rte iframe").forEach((e) => {
        (-1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo")) || (e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>");
    }),
    new main_default(document.documentElement).on("click", "[data-smooth-scroll]", (e, t) => {
        let i = document.querySelector(t.getAttribute("href"));
        i && (e.preventDefault(), i.scrollIntoView({ behavior: "smooth", block: "start" }));
    }),
    document.addEventListener("keyup", function (e) {
        "Tab" === e.key && (document.body.classList.remove("no-focus-outline"), document.body.classList.add("focus-outline"));
    });
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.2.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 7.5.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/
